<template>
  <b-container
    :class="{
      'container--stepTimer': orderTimer && !isExpired
    }"
    class="px-0 container--width overflow-hidden">
    <b-row>
      <b-col cols="12">
        <div class="event-image position-relative overflow-hidden">
          <b-img :src="event.cover" />
        </div>
      </b-col>
      <div v-if="orderTimer && !isExpired">
        <div
          class="stepTimer p-1 p-md-0 d-md-none">
          <div class="stepTimer__block">
            <i class="fas fa-clock st_color_gray_light stepTimer__icon" />
            <span class="stepTimer__prefix">
              請於
            </span>
            <span class="stepTimer__time">
              {{ orderTimer.hour | twoDigits }}:{{ orderTimer.minute | twoDigits }}:{{ orderTimer.second | twoDigits }}
            </span>
            <span class="stepTimer__suffix">
              內完成
              <span class="d-md-none">
                報名資料
              </span>
            </span>
          </div>
        </div>
        <div
          class="stepTimer p-1 p-md-0 d-none d-md-block"
          ref="orderTimer">
          <div class="stepTimer__block">
            <i class="fas fa-clock st_color_gray_light stepTimer__icon" />
            <span class="stepTimer__prefix">
              請於
            </span>
            <span class="stepTimer__time">
              {{ orderTimer.hour | twoDigits }}:{{ orderTimer.minute | twoDigits }}:{{ orderTimer.second | twoDigits }}
            </span>
            <span class="stepTimer__suffix">
              內完成
              <span class="d-md-none">
                報名資料
              </span>
            </span>
          </div>
        </div>
      </div>
      <b-col cols="12" v-if="loaded" :class="{ 'expired__paidInfo': !!(isExpired && expiredArea === 'paidInfo'), 'expired__userInfo': !!(isExpired && expiredArea === 'userInfo') }">
        <md-steppers
          :class="{
            'md-steppers--isExpired': isExpired
          }"
          md-dynamic-height md-linear
          :md-active-step="step"
          ref="step">
          <md-step id="stepSelect" :md-done.sync="done.stepSelect" md-label="選擇票種" :md-editable="false">
            <b-container
              class="stepSelect mx-auto"
              v-if="products.length">
              <h3 class="stepSelect__title text-center st_main-regular-big">
                選擇票種
              </h3>
              <b-row
                v-for="(product, productIndex) in products"
                :key="product.identity"
                class="justify-content-center stepSelect__ticket"
                :class="{
                  'mb-5': products.length - 1 !== productIndex
                }">
                <b-col cols="12">
                  <b-row
                    noGutters
                    class="align-items-center">
                    <b-col
                      class="text-center d-none d-md-block"
                      cols="1"
                      lg="2">
                      <md-checkbox
                        :id="`checkbox-${product.identity}`"
                        class="st_color_main_light m-0 stepSelect__ticket__checkbox"
                        v-model="selectProducts"
                        :value="product.identity"
                        :disabled="checkProductDisable(product)" />
                    </b-col>
                    <b-col
                      cols="12"
                      md="11"
                      lg="10">
                      <label
                        @click="showToast(product)"
                        :class="{
                          'stepSelect__ticket-label--selected': selectProducts.includes(product.identity),
                          'stepSelect__ticket-label--non-start': !checkProductStarted(product),
                          'stepSelect__ticket-label--fulled': checkProductStarted(product) && checkProductFulled(product),
                          'stepSelect__ticket-label--ended': checkProductStarted(product) && !checkProductFulled(product) && checkProductEnded(product)
                        }"
                        class="stepSelect__ticket-label w-100 pl-4 pr-4 pr-md-2 mb-0 pt-3 pb-3 d-flex justify-content-center align-items-md-stretch"
                        :for="`checkbox-${product.identity}`">
                        <b-row
                          noGutters
                          class="align-content-between align-items-md-center w-100">
                          <b-col
                            class="stepSelect__ticket-label-left pr-md-5 pb-2 pb-md-0 text-center text-md-left d-md-flex align-items-md-center"
                            cols="12"
                            md="8">
                            <div class="stepSelect__ticket-label-left__dashed-line" />
                            <div class="overflow-hidden">
                              <div class="st_heading-medium-bigger text-nowrap stepSelect__ticket-label__name">
                                {{ product.title }}
                              </div>
                              <div
                                :class="{
                                  'mb-3': (product.buyConditions.channel.type === 'atLeastOne' || product.buyConditions.channel.list.length) && product.buyConditions.event.list.length && !checkProductNeedOr(product),
                                }"
                                class="st_heading-regular-small mb-2 mb-md-0 stepSelect__ticket-label__event-name">
                                {{ event.title }}
                              </div>
                              <div
                                class="stepSelect__ticket-label__conditions"
                                v-if="product.buyConditions">
                                <div class="mb-3 mb-md-0">
                                  <div
                                    v-if="checkProductNeedOr(product)"
                                    class="st_caption-medium-small text-left stepSelect__ticket-label__conditions__or mt-md-1 mb-2 mb-md-0 pb-1 pb-md-0 pt-md-1">
                                    <i class="fas fa-minus-circle st_color_gray_light" />
                                    限符合以下任一條件:
                                  </div>

                                  <div
                                    class="d-inline-flex align-items-center"
                                    v-if="product.buyConditions.operator === 'all'">
                                    <i class="fas fa-check st_color_gray_light mr-1" />
                                    <span class="st_caption-light-small mr-1">
                                      適用
                                    </span>
                                    <span class="st_caption-medium-small stepSelect__ticket-label__conditions__forAll">
                                      所有人
                                    </span>
                                  </div>

                                  <div
                                    v-if="product.buyConditions.operator !== 'all' && product.buyConditions.channel.type !== 'all'"
                                    :class="{
                                      'mb-1': product.buyConditions.channel.list.length,
                                      'text-left': product.buyConditions.channel.list.length || product.buyConditions.event.list.length,
                                    }"
                                    class="stepSelect__ticket-label__conditions__forSubscription">
                                    <span
                                      :class="{
                                        'd-flex': !product.buyConditions.event.list.length,
                                        'justify-content-center': !product.buyConditions.event.list.length,
                                        'mb-2': !product.buyConditions.event.list.length,
                                      }"
                                      class="st_caption-medium-small align-items-center d-md-inline-flex pr-1 mb-md-0">
                                      <i
                                        v-if="!checkProductNeedOr(product)"
                                        class="fas fa-minus-circle st_color_gray_light mr-1" />
                                      <i
                                        class="mr-2"
                                        v-else>-</i>限訂閱者{{ product.buyConditions.channel.list.length ? ':' : '' }}
                                    </span>
                                    <span
                                      :class="{
                                        'd-block': !product.buyConditions.event.list.length,
                                        'text-center': !product.buyConditions.event.list.length
                                      }"
                                      class="stepSelect__ticket-label__conditions__forSubscription__channel-items d-md-inline-block m-n1 text-md-left"
                                      v-if="product.buyConditions.channel.type === 'whitelist'">
                                      <span
                                        class="d-inline-block p-1 text-left"
                                        v-for="channel in product.buyConditions.channel.list"
                                        :key="channel">
                                        <nuxt-link
                                          class="st_accent-medium-small d-inline-block pl-2 pr-2 pt-1 pb-1"
                                          v-if="getChannelByIdentity(channel)"
                                          :to="{ name: 'u-uid-service-product-pid', params: { uid: getChannelByIdentity(channel).account.serial, pid: getChannelByIdentity(channel).identity } }">
                                          {{ getChannelByIdentity(channel).title }}
                                        </nuxt-link>
                                      </span>
                                    </span>
                                  </div>
                                  <div
                                    v-if="!product.buyConditions.operator !== 'all' && product.buyConditions.event.type !== 'all'"
                                    class="stepSelect__ticket-label__conditions__forEvent text-left st_caption-medium-small">
                                    <span class="d-inline-flex align-items-center">
                                      <i
                                        v-if="!checkProductNeedOr(product)"
                                        class="fas fa-minus-circle st_color_gray_light mr-1" />
                                      <i
                                        class="mr-2"
                                        v-else>-</i>限參與
                                    </span>
                                    <span
                                      :class="{
                                        'px-1': eventIndex !== 0 && product.buyConditions.event.list.length - 1 !== eventIndex,
                                        'pr-1': eventIndex === 0,
                                        'pl-1': product.buyConditions.event.list.length - 1 === eventIndex
                                      }"
                                      class="d-inline-block"
                                      v-for="(oneEvent, eventIndex) in product.buyConditions.event.list"
                                      :key="oneEvent">
                                      <nuxt-link
                                        class="st_caption-regular-small"
                                        v-if="getEventByIdentity(oneEvent)"
                                        :to="{ name: 'event-eid', params: { eid: getEventByIdentity(oneEvent).identity } }">
                                        「{{ getEventByIdentity(oneEvent).title }}」{{ product.buyConditions.event.list.length - 1 !== eventIndex ? '、' : '' }}
                                      </nuxt-link>
                                    </span>
                                    <span>
                                      報名者
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-col>
                          <b-col
                            class="text-center stepSelect__ticket-label-right position-static d-flex flex-row-reverse justify-content-center align-items-baseline d-md-block"
                            cols="12"
                            md="4">
                            <div>
                              <md-checkbox
                                :class="{
                                  'd-none': !checkProductStarted(product) || checkProductStarted(product) && !checkProductFulled(product) && checkProductEnded(product)
                                }"
                                :id="`checkbox-${product.identity}`"
                                class="st_color_main_light m-0 stepSelect__ticket__checkbox mr-2 d-md-none"
                                v-model="selectProducts"
                                :value="product.identity"
                                :disabled="checkProductDisable(product)" />
                              <span
                                class="st_accent-regular-base stepSelect__ticket-label__currency" v-if="product.price !== 0">
                                NT
                              </span>
                              <span
                                class="st_color_sub stepSelect__ticket-label__price">
                                {{ product.price === 0 ? '免費' : product.price.toLocaleString() }}
                              </span>
                            </div>
                            <div
                              :class="{
                                'mt-md-2': !(checkProductStarted(product) && checkProductFulled(product)),
                                'mr-2': !(checkProductStarted(product) && checkProductFulled(product)),
                              }"
                              class="stepSelect__ticket-label__message st_highlight-medium-base mx-md-auto d-flex align-items-center justify-content-center"
                              v-if="!checkProductStarted(product) || checkProductStarted(product) && checkProductFulled(product) || checkProductStarted(product) && !checkProductFulled(product) && checkProductEnded(product)">
                              {{ checkProductStarted(product) && checkProductFulled(product) ? '已完售' : '' }}
                              {{ !checkProductStarted(product) ? '尚未開放' : '' }}
                              {{ checkProductStarted(product) && !checkProductFulled(product) && checkProductEnded(product) ? '結束售票' : '' }}
                            </div>
                          </b-col>
                        </b-row>
                      </label>
                    </b-col>
                  </b-row>
                  <b-row noGutters>
                    <b-col
                      offset-md="1"
                      offset-lg="2"
                      cols="12"
                      md="11"
                      lg="10">
                      <b-collapse
                        class="stepSelect__ticket__detail pt-2 pt-md-3 pl-3 pl-md-4 pr-3 pr-md-4 pb-3"
                        @shown="changeStepperHeight"
                        @hidden="changeStepperHeight"
                        :id="`collapse-${product.identity}`">
                        <div class="st_color_gray text-center d-md-none stepSelect__ticket__detail-title mb-2">
                          票種說明
                        </div>
                        <div class="stepSelect__ticket__detail-usage pl-2 pl-md-0 mb-3 mb-md-1">
                          <div>
                            <span class="st_color_gray stepSelect__ticket__detail-label d-block d-md-inline mr-2">
                              售票期間
                            </span>
                            <span class="stepSelect__ticket__detail-date">
                              {{ $moment(product.buyPeriod.start).format('YYYY/MM/DD(dd) HH:mm') }} ~ {{ $moment(product.buyPeriod.end).format('YYYY/MM/DD(dd) HH:mm') }}
                            </span>
                          </div>
                          <div>
                            <span class="st_color_gray stepSelect__ticket__detail-label d-block d-md-inline mr-2">
                              使用期間
                            </span>
                            <span class="stepSelect__ticket__detail-date">
                              {{ $moment(product.detail.usePeriod.start).format('YYYY/MM/DD(dd) HH:mm') }} ~ {{ $moment(product.detail.usePeriod.end).format('YYYY/MM/DD(dd) HH:mm') }}
                            </span>
                          </div>
                        </div>
                        <span class="stepSelect__ticket__detail-content">{{ product.content }}</span>
                      </b-collapse>
                      <div class="d-flex justify-content-center mt-3">
                        <b-button
                          class="stepSelect__ticket__collapsed-button d-flex align-items-center border-0 p-0 st_background_transparent st_link-medium-base"
                          v-b-toggle="`collapse-${product.identity}`">
                          票種說明
                          <i class="fas fa-sort-down st_color_gray_light ml-1" />
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <b-button
                class="st_main_l stepSelect__ticket__next-button mb-3 d-block mx-auto"
                :disabled="selectProducts.length === 0 || buttonLoading" @click.prevent="stepSelectToUserInfo">
                下一步
              </b-button>
              <nuxt-link
                class="st_main_l stepSelect__ticket__previous-button d-block mx-auto text-center"
                :to="{
                  name: 'event-eid',
                  params: $route.params
                }">
                返回活動頁
              </nuxt-link>
            </b-container>
          </md-step>
          <md-step id="stepUserInfo" :md-done.sync="done.stepUserInfo" md-label="報名資料" :md-editable="false">
            <b-container
              class="stepUserInfo"
              v-if="order && order.purchases && order.purchases.length && !isExpired">
              <h2 class="st_main-regular-big text-center mb-3 mb-md-4">
                填寫報名資料
              </h2>
              <b-row
                v-for="(purchase, purchaseIndex) in order.purchases"
                :key="purchase.identity"
                class="justify-content-center stepUserInfo__purchase"
                :class="{
                  'mb-4': purchaseIndex !== order.purchases.length - 1
                }">
                <b-col cols="12" md="6">
                  <div
                    :class="{
                      'mb-2': purchaseIndex !== 0
                    }"
                    class="d-flex justify-content-between align-items-end">
                    <span
                      :class="{
                        'mb-2': purchaseIndex === 0
                      }"
                      class="st_caption-light-small d-none d-md-inline-block">
                      報名資料{{ purchaseIndex + 1 }}
                    </span>
                    <b-button
                      v-if="purchaseIndex !== 0"
                      @click.prevent="copyPreviousPurchaseUserInfo(purchaseIndex)"
                      class="stepUserInfo__purchase__copy st_background_transparent st_color_main_lightest py-0 d-none d-md-block">
                      資料同上
                    </b-button>
                  </div>
                  <b-container
                    class="st_background_white stepUserInfo__purchase__form" fluid>
                    <h3 class="st_caption-regular-big text-center">
                      {{ purchase.product.title }}
                    </h3>
                    <div
                      :class="{
                        'mb-2': purchaseIndex !== 0
                      }"
                      class="d-flex justify-content-between">
                      <span
                        :class="{
                          'mt-1': purchaseIndex !== 0,
                          'mb-3': purchaseIndex === 0
                        }"
                        class="st_caption-regular-smaller d-inline-block pl-1">
                        ＊表示必填資料
                      </span>
                      <b-button
                        v-if="purchaseIndex !== 0"
                        @click.prevent="copyPreviousPurchaseUserInfo(purchaseIndex)"
                        class="stepUserInfo__purchase__copy st_background_transparent st_color_main_lightest py-0 d-md-none">
                        資料同上
                      </b-button>
                    </div>
                    <b-row class="mb-4">
                      <b-col
                        class="mb-2"
                        cols="12">
                        <span class="st_color_main_light d-inline-block pl-2">
                          ＊ 姓名
                        </span>
                      </b-col>
                      <b-col cols="12">
                        <Input
                          class="my-0"
                          inputClass="st_border_gray_lighter"
                          type="text"
                          placeholder="輸入您的姓名（必填）"
                          :feedback="verificationFeedback.name"
                          :status="!verificationName(purchase.detail.userInfo.name, true) ? 'is-invalid' : ''"
                          v-model="purchase.detail.userInfo.name" />
                      </b-col>
                    </b-row>
                    <b-row class="mb-4">
                      <b-col
                        class="mb-2"
                        cols="12">
                        <span class="st_color_main_light d-inline-block pl-2">
                          ＊ 聯絡信箱
                        </span>
                      </b-col>
                      <b-col cols="12">
                        <Input
                          class="my-0"
                          inputClass="st_border_gray_lighter"
                          type="text"
                          placeholder="輸入您的信箱（必填）"
                          :feedback="verificationFeedback.email"
                          :status="!verificationEmail(purchase.detail.userInfo.email, true) ? 'is-invalid' : ''"
                          v-model="purchase.detail.userInfo.email" />
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col
                        cols="12">
                        <span class="st_color_main_light d-inline-block pl-2">
                          ＊ 聯絡電話
                        </span>
                      </b-col>
                      <b-col cols="12">
                        <Input
                          class="my-0"
                          inputClass="st_border_gray_lighter"
                          type="text"
                          placeholder="輸入您的手機號碼（必填）"
                          :feedback="verificationFeedback.phone"
                          :status="!verificationPhone(purchase.detail.userInfo.phone, true) ? 'is-invalid' : ''"
                          v-model="purchase.detail.userInfo.phone" />
                      </b-col>
                    </b-row>
                  </b-container>
                </b-col>
              </b-row>
              <b-button class="d-block mx-auto st_main_l stepUserInfo__purchase__next-button mb-3" :disabled="!verificationAllUserInfo || buttonLoading" @click.prevent="stepUserInfoToPaidInfo">
                下一步
              </b-button>
              <b-button
                @click.prevent="cancelOrder"
                class="st_sub_l stepUserInfo__purchase__cancel-button d-block mx-auto text-center">
                取消報名
              </b-button>
            </b-container>
            <b-container
              class="expiration"
              v-else-if="isExpired">
              <b-row class="justify-content-center text-center">
                <b-col
                  cols="11"
                  md="6"
                  class="expiration__content st_background_white">
                  <span class="st_main-medium-base d-inline-block mb-1 mb-md-0">本次訂購已逾期，請重新購票</span>
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-clock st_color_gray_light mr-1" />
                    <span class="expiration__content__timer">00:00:00</span>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-button
                    @click.prevent="reloadPage"
                    class="st_main_l d-block mx-auto mb-3 w-100 expiration__resubmit-button">
                    重新報名
                  </b-button>
                  <nuxt-link
                    class="st_main_l d-inline-block w-100 expiration__back"
                    to="">
                    返回探索活動
                  </nuxt-link>
                </b-col>
              </b-row>
            </b-container>
          </md-step>
          <md-step id="stepPaidInfo" :md-done.sync="done.stepPaidInfo" md-label="付款資訊" :md-editable="false">
            <b-container v-if="order && order.state && order.state === 'paidInfo' && !isExpired" class="container--width">
              <b-row class="justify-content-center payChoose--borderDashed pb-md-5">
                <b-col md="10" class="st_background_white pt-4 px-0 mb-md-3">
                  <b-row class="mb-5 mb-md-4 pb-md-1 d-none d-md-block">
                    <b-col class="st_main-regular-biggest text-center mb-2">
                      1.選擇付款方式
                    </b-col>
                  </b-row>

                  <b-row class="justify-content-center payChoose" noGutters>
                    <b-col cols="12" class="mb-3 d-md-none">
                      <h2 class="st_title-regular-big text-center">
                        1.選擇付款資訊
                      </h2>
                    </b-col>

                    <b-col cols="12" md="10">
                      <b-container class="payChoose--borderMobile payChoose--borderDesktop st_border_gray_lighter border-width-2px" fluid>
                        <b-row>
                          <b-col
                            cols="12" md="3"
                            class="st_background_gray_lighter payChoose__way__title d-flex align-items-center justify-content-center justify-content-md-start">
                            <h5 class="st_color_gray_darker st_none-none-base py-2 mb-0 ml-md-2">
                              付款方式
                            </h5>
                          </b-col>
                          <b-col cols="12" md="9" class="py-3 px-4 py-md-4">
                            <b-row class="mb-3 px-3 px-md-0">
                              <b-col cols="auto" class="pr-0">
                                <md-radio
                                  class="st_radio mx-0 paymentMethod align-items-start"
                                  v-model="pay"
                                  :disabled="checkPayDisable('LINEPAY/NORMAL')"
                                  value="LINEPAY/NORMAL">
                                  <svg-icon
                                    class="mb-1"
                                    name="icon_linepay"
                                    :width="69"
                                    :height="20" />
                                  <span class="st_caption-light-small ml-2">
                                    免手續費
                                  </span>
                                </md-radio>
                              </b-col>
                              <b-col class="text-right pl-0">
                                <b-link
                                  class="payChoose__linePay"
                                  target="_blank"
                                  href="http://official-blog.line.me/tw/archives/39016757.html">
                                  LINE Pay 綁定教學
                                </b-link>
                              </b-col>
                            </b-row>

                            <b-row class="mb-3 px-3 px-md-0">
                              <b-col cols="12">
                                <md-radio
                                  class="st_radio st_color_gray_darker mx-0 paymentMethod align-items-start"
                                  v-model="pay"
                                  :disabled="checkPayDisable('TAPPAY/CREDIT')"
                                  value="TAPPAY/CREDIT">
                                  信用卡
                                  <span class="st_caption-light-small ml-2">
                                    一次付清免手續費<br>
                                    分期付款僅限使用玉山及台新銀行之信用卡
                                  </span>
                                </md-radio>
                              </b-col>
                              <b-col cols="12" md="6" offset-md="1" class="pl-5 pl-md-0" v-if="pay === 'TAPPAY/CREDIT'">
                                <div class="st-select mt-1">
                                  <md-field class="mt-0 pt-0 px-3">
                                    <md-select
                                      id="payTappaySelect" mdDense :disabled="checkPayDisable('TAPPAY/CREDIT_3') && checkPayDisable('TAPPAY/CREDIT_6') && checkPayDisable('TAPPAY/CREDIT_12')"
                                      name="payTappaySelect" placeholder="一次付清" v-model="payTappay">
                                      <md-option :value="''">
                                        一次付清
                                      </md-option>
                                      <md-option
                                        :disabled="checkPayDisable('TAPPAY/CREDIT_3')"
                                        :value="3">
                                        分3期(手續費0.3%)
                                      </md-option>
                                      <md-option
                                        :disabled="checkPayDisable('TAPPAY/CREDIT_6')"
                                        :value="6">
                                        分6期(手續費0.8%)
                                      </md-option>
                                      <md-option
                                        :disabled="checkPayDisable('TAPPAY/CREDIT_12')"
                                        :value="12">
                                        分12期(手續費4.3%)
                                      </md-option>
                                    </md-select>
                                  </md-field>
                                </div>
                              </b-col>
                            </b-row>

                            <b-row class="mb-3 px-3 px-md-0">
                              <b-col>
                                <md-radio
                                  class="st_radio st_color_gray_darker mx-0 paymentMethod align-items-start"
                                  v-model="pay"
                                  :disabled="checkPayDisable('ECPAY/ATM')"
                                  value="ECPAY/ATM">
                                  ATM 付款
                                  <span class="st_caption-light-small ml-2">
                                    手續費 5~26 元
                                    <span id="question-mark-atm-mobile" class="question-mark">
                                      ?
                                    </span>
                                  </span>
                                </md-radio>

                                <b-tooltip target="question-mark-atm-mobile">
                                  ATM繳費需收取付款金額 1% 手續費， 最低5元；最高26元。
                                  且此手續費將不列入退費受理範圍。
                                </b-tooltip>
                              </b-col>
                            </b-row>

                            <b-row class=" px-3 px-md-0">
                              <b-col>
                                <md-radio
                                  class="st_radio st_color_gray_darker mx-0 paymentMethod align-items-start"
                                  v-model="pay"
                                  :disabled="checkPayDisable('ECPAY/CVS')"
                                  value="ECPAY/CVS">
                                  超商付款
                                  <span class="st_caption-light-small ml-2">
                                    手續費 30 元
                                    <span id="question-mark-cvs-mobile" class="question-mark">
                                      ?
                                    </span>
                                  </span>
                                </md-radio>

                                <b-tooltip target="question-mark-cvs-mobile">
                                  超商代碼繳費需收取 30 元手續費，
                                  且此手續費將不列入退費受理範圍。
                                </b-tooltip>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>

                        <b-row class="st_border_gray_lighter justify-content-center creditCard__block py-3 px-4 px-md-0 py-md-4" v-if="pay === 'LINEPAY/NORMAL' && cardListLinePay && cardListLinePay.length">
                          <b-col md="10" class="creditCard__select px-0">
                            <b-col cols="12" class="mb-3">
                              <md-radio
                                class="st_radio mx-0"
                                v-model="useNewCard"
                                :value="false">
                                我的 LINE Pay 卡
                              </md-radio>
                            </b-col>
                            <b-col md="11" class="mx-auto" v-if="!useNewCard">
                              <multiselect
                                v-model="paymentCard" placeholder="請選擇卡片" :options="cardListLinePay" openDirection="bottom"
                                trackBy="id" :searchable="false" :showLabels="false" :allowEmpty="false" :disabled="!cardListLinePay.length">
                                <template slot="singleLabel" slot-scope="props">
                                  <b-row class="ml-0 align-items-center">
                                    <b-col class="ml-1 px-0 d-flex">
                                      <svg-icon :name="`icon_card_${getCardType(props.option.type)}`" class="card__icon" width="30" height="20" />
                                      <span class="text-overflow-1-line" :class="(!props.option.name || props.option.name === '') ? 'st_color_gray_light' : 'st_color_main'">
                                        {{ props.option.name ? props.option.name : '未命名' }}
                                      </span>
                                    </b-col>
                                    <b-col class="ml-auto mr-4 px-0" cols="auto">
                                      <span class="d-md-none">
                                        ...
                                      </span>
                                      <span class="d-none d-md-inline">
                                        ****-****-
                                      </span>
                                      ****-{{ props.option.lastFour }}
                                    </b-col>
                                  </b-row>
                                </template>
                                <template slot="option" slot-scope="props">
                                  <b-row class="ml-0 align-items-center">
                                    <b-col class="ml-1 px-0 d-flex">
                                      <svg-icon :name="`icon_card_${getCardType(props.option.type)}`" class="card__icon" width="30" height="20" />
                                      <span class="text-overflow-1-line" :class="(!props.option.name || props.option.name === '') ? 'st_color_gray_light' : 'st_color_main'">
                                        {{ props.option.name ? props.option.name : '未命名' }}
                                      </span>
                                    </b-col>
                                    <b-col class="ml-auto mr-4 px-0" cols="auto">
                                      <span class="d-md-none">
                                        ...
                                      </span>
                                      <span class="d-none d-md-inline">
                                        ****-****-
                                      </span>
                                      ****-{{ props.option.lastFour }}
                                    </b-col>
                                  </b-row>
                                </template>
                              </multiselect>
                            </b-col>
                            <b-col cols="12" class="mt-3 mt-md-4">
                              <md-radio
                                class="st_radio mx-0"
                                v-model="useNewCard"
                                :value="true">
                                授權新的 LINE Pay 卡
                              </md-radio>
                            </b-col>
                          </b-col>
                        </b-row>

                        <b-row class="st_border_gray_lighter justify-content-center creditCard__block py-3 px-4 px-md-0 py-md-4" v-if="pay === 'TAPPAY/CREDIT'">
                          <b-col md="10" class="creditCard__select px-0" v-if="cardListTapPay && cardListTapPay.length">
                            <b-col cols="12" class="mb-3">
                              <md-radio
                                class="st_radio mx-0"
                                v-model="useNewCard"
                                :value="false">
                                我的信用卡
                              </md-radio>
                            </b-col>
                            <b-col md="11" class="mx-auto" v-if="!useNewCard">
                              <multiselect
                                v-model="paymentCard" placeholder="請選擇卡片" :options="cardListTapPay" openDirection="bottom"
                                trackBy="id" :searchable="false" :showLabels="false" :allowEmpty="false" :disabled="!cardListTapPay.length">
                                <template slot="singleLabel" slot-scope="props">
                                  <b-row class="ml-0 align-items-center">
                                    <b-col class="ml-1 px-0 d-flex">
                                      <svg-icon :name="`icon_card_${getCardType(props.option.type)}`" class="card__icon" width="30" height="20" />
                                      <span class="text-overflow-1-line" :class="(!props.option.name || props.option.name === '') ? 'st_color_gray_light' : 'st_color_main'">
                                        {{ props.option.name ? props.option.name : '未命名' }}
                                      </span>
                                    </b-col>
                                    <b-col class="ml-auto mr-4 px-0" cols="auto">
                                      <span class="d-md-none">
                                        ...
                                      </span>
                                      <span class="d-none d-md-inline">
                                        ****-****-
                                      </span>
                                      ****-{{ props.option.lastFour }}
                                    </b-col>
                                  </b-row>
                                </template>
                                <template slot="option" slot-scope="props">
                                  <b-row class="ml-0 align-items-center">
                                    <b-col class="ml-1 px-0 d-flex">
                                      <svg-icon :name="`icon_card_${getCardType(props.option.type)}`" class="card__icon" width="30" height="20" />
                                      <span class="text-overflow-1-line" :class="(!props.option.name || props.option.name === '') ? 'st_color_gray_light' : 'st_color_main'">
                                        {{ props.option.name ? props.option.name : '未命名' }}
                                      </span>
                                    </b-col>
                                    <b-col class="ml-auto mr-4 px-0" cols="auto">
                                      <span class="d-md-none">
                                        ...
                                      </span>
                                      <span class="d-none d-md-inline">
                                        ****-****-
                                      </span>
                                      ****-{{ props.option.lastFour }}
                                    </b-col>
                                  </b-row>
                                </template>
                              </multiselect>
                            </b-col>
                            <b-col cols="12" class="mt-3 mt-md-4">
                              <md-radio
                                class="st_radio mx-0"
                                v-model="useNewCard"
                                :value="true">
                                使用其他信用卡
                              </md-radio>
                            </b-col>
                          </b-col>
                          <b-col cols="12" class="creditCard__newCard px-3 px-md-0 mt-3" v-if="useNewCard">
                            <b-col cols="12" class="creditCard__inside creditCard__inside__top mx-auto mb-4">
                              <b-row class="creditCard__numberLabel pb-3">
                                <b-col class="st_color_main_light px-0">
                                  信用卡卡號
                                </b-col>
                                <b-col class="text-right px-0">
                                  <svg-icon name="icon_card_visa" width="30" height="20" />
                                  <svg-icon name="icon_card_master" width="30" height="20" />
                                  <svg-icon name="icon_card_jcb" width="30" height="20" />
                                  <svg-icon name="icon_card_amex" width="30" height="20" />
                                </b-col>
                              </b-row>
                              <b-row class="creditCard__number px-3 py-2" :class="`creditCard__state--${cardNumberState}`">
                                <b-col cols="auto" class="px-0">
                                  <svg-icon :name="`icon_card_${card.type}`" class="creditCard__number__icon" width="30" height="20" />
                                </b-col>
                                <b-col class="px-0">
                                  <input placeholder="0000-0000-0000-0000" v-model="card.number" class="creditCard__input creditCard__number__input" :maxLength="card.type === 'amex' ? 18 : 19">
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col cols="12" class="creditCard__inside creditCard__inside__bottom mx-auto mb-1">
                              <b-row>
                                <b-col cols="6" md="5" class="pl-0 pr-2">
                                  <b-col class="st_color_main_light px-0 mb-2">
                                    有效期限
                                  </b-col>
                                  <b-col class="px-0 creditCard__expiry" :class="`creditCard__state--${cardExpiryState}`">
                                    <input placeholder="月/年" v-model="card.expiry" class="creditCard__input creditCard__expiry__input" maxLength="5">
                                  </b-col>
                                </b-col>
                                <b-col cols="6" md="5" offset-md="2" class="px-0">
                                  <b-col class="st_color_main_light px-0 mb-2">
                                    卡片末{{ card.type === 'amex' ? '四' : '三' }}碼
                                  </b-col>
                                  <b-col class="px-0 creditCard__ccv" :class="`creditCard__state--${cardCcvState}`">
                                    <input :placeholder="card.type === 'amex' ? '1234' : '123'" v-model="card.ccv" class="creditCard__input creditCard__ccv__input" :maxLength="card.type === 'amex' ? 4 : 3">
                                  </b-col>
                                </b-col>
                              </b-row>
                            </b-col>
                          </b-col>
                        </b-row>

                        <b-row class="payChoose__amount">
                          <b-col cols="12" md="3" class="st_background_gray_lighter payChoose__amount__title d-flex align-items-center align-items-md-start justify-content-center justify-content-md-start">
                            <h5 class="st_color_gray_darker st_none-none-base py-2 py-md-4 ml-md-2 mb-0">
                              付款金額
                            </h5>
                          </b-col>

                          <b-col cols="12" md="9" class="py-2 px-4 px-md-3 pb-md-4">
                            <b-row class="px-4">
                              <b-col class="text-right payChoose--borderBottom pr-0 pr-md-2 pt-3 pt-md-4 pb-2">
                                <span class="st_main-medium-biggest">
                                  ${{ payPrice }}
                                </span>
                                <span class="st_main-none-base">
                                  新台幣
                                </span>
                              </b-col>

                              <b-col cols="12">
                                <b-row class="mt-3 px-md-2">
                                  <b-col class="st_disable-medium-small pl-0" cols="auto">
                                    小計:
                                  </b-col>
                                  <b-col class="pr-0">
                                    <div class="d-flex justify-content-between mb-1" v-for="cart in order.carts" :key="cart.product">
                                      <span class="st_none-medium-small st_color_gray ml-md-5">
                                        {{ cart.title }} {{ cart.quantity }} 張
                                      </span>
                                      <span class="payChoose__price">
                                        ${{ cart.price }}
                                      </span>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                      <span class="st_none-medium-small st_color_gray ml-md-5">
                                        手續費
                                      </span>
                                      <span class="payChoose__payFee">
                                        ${{ payFee }}
                                      </span>
                                    </div>
                                  </b-col>
                                </b-row>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-container>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="d-md-none">
                <b-col class="payChoose__margin" />
              </b-row>

              <b-row class="receiptWrite receiptWrite--borderMobile receiptWrite--borderDashed st_background_white pt-3 mt-md-5 pb-5 pb-4">
                <b-col cols="12" class="mb-3 mt-1 mt-md-3 mb-md-4">
                  <h2 class="text-center receiptWrite__title">
                    2.填寫發票資訊
                  </h2>
                </b-col>

                <b-container fluid>
                  <b-row class="mb-4 pb-2 pb-md-3">
                    <b-col cols="12" class="text-center">
                      <md-radio
                        class="st_radio st_color_main_light"
                        v-model="formData.accType"
                        value="1">
                        個人戶發票
                      </md-radio>

                      <md-radio
                        class="st_radio st_color_main_light"
                        v-model="formData.accType"
                        value="2">
                        公司發票
                      </md-radio>
                    </b-col>
                  </b-row>

                  <b-row class="justify-content-center d-none d-md-flex">
                    <b-col cols="12" md="7" lg="5" class="text-right receiptWrite__required pl-0">
                      <h6 class="st_color_gray_dark st_none-none-smaller">
                        ＊表示必填
                      </h6>
                    </b-col>
                  </b-row>

                  <b-row class="justify-content-center">
                    <b-col cols="12" md="7" lg="5" class="receiptWrite__personal">
                      <b-row class="py-3" v-if="formData.accType === '1'">
                        <b-col class="mb-2">
                          <h5 class="receiptWrite__inputTitle d-inline">
                            ＊ 付款人姓名
                          </h5>
                        </b-col>
                        <b-col class="st_caption-medium-smaller d-md-none text-right">
                          ＊表示必填
                        </b-col>
                        <b-col cols="12" class="pl-4">
                          <Input
                            class="my-0"
                            inputClass="st_border_gray_lighter"
                            type="text"
                            placeholder="輸入您的姓名（必填）"
                            :feedback="verificationFeedback.name"
                            :status="!verificationName(formData.name, true) ? 'is-invalid' : ''"
                            v-model="formData.name" />
                        </b-col>
                      </b-row>

                      <b-row class="py-3" v-if="formData.accType === '2'">
                        <b-col class="mb-2">
                          <h5 class="receiptWrite__inputTitle d-inline">
                            ＊ 公司名稱
                          </h5>
                        </b-col>
                        <b-col class="st_caption-medium-smaller d-md-none text-right">
                          ＊表示必填
                        </b-col>

                        <b-col cols="12" class="pl-4">
                          <Input
                            class="my-0"
                            inputClass="st_border_gray_lighter"
                            type="text"
                            placeholder="請輸入公司名稱（必填）"
                            :feedback="verificationFeedback.companyName"
                            :status="!verificationCompanyName(formData.companyName, true) ? 'is-invalid' : ''"
                            v-model="formData.companyName" />
                        </b-col>
                      </b-row>

                      <b-row class="py-3" v-if="formData.accType === '2'">
                        <b-col class="mb-2">
                          <h5 class="receiptWrite__inputTitle">
                            ＊ 公司統編
                          </h5>
                        </b-col>

                        <b-col cols="12" class="pl-4">
                          <Input
                            class="my-0"
                            inputClass="st_border_gray_lighter"
                            type="text"
                            placeholder="例：12345678 （必填）"
                            :feedback="!verificationCompanyId(formData.companyId, true, true) ? verificationFeedback.companyId.type : verificationFeedback.companyId.limitation"
                            :status="(!verificationCompanyId(formData.companyId, true, true) || !verificationCompanyId(formData.companyId, true)) ? 'is-invalid' : ''"
                            v-model="formData.companyId" />
                        </b-col>
                      </b-row>

                      <b-row class="py-3">
                        <b-col cols="auto" class="mb-2">
                          <h5 class="receiptWrite__inputTitle">
                            ＊ 聯絡信箱
                          </h5>
                        </b-col>
                        <b-col class="st_caption-light-small text-right pl-0">
                          電子發票將寄送至您填寫的聯絡信箱
                        </b-col>
                        <b-col cols="12" class="pl-4">
                          <Input
                            class="my-0"
                            inputClass="st_border_gray_lighter"
                            type="text"
                            placeholder="例：ScanTrader@gmail.com（必填）"
                            :feedback="verificationFeedback.email"
                            :status="!verificationEmail(formData.email, true) ? 'is-invalid' : ''"
                            v-model="formData.email" />
                        </b-col>
                      </b-row>

                      <b-row class="py-3">
                        <b-col class="mb-2">
                          <h5 class="receiptWrite__inputTitle">
                            ＊ 聯絡電話
                          </h5>
                        </b-col>

                        <b-col cols="12" class="pl-4">
                          <Input
                            class="my-0"
                            inputClass="st_border_gray_lighter"
                            type="text"
                            placeholder="請輸入聯絡電話（必填）"
                            :feedback="verificationFeedback.phone"
                            :status="!verificationPhone(formData.phone, true) ? 'is-invalid' : ''"
                            v-model="formData.phone" />
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-container>
              </b-row>

              <b-row class="d-md-none">
                <b-col class="receiptWrite__margin" />
              </b-row>

              <b-row class="justify-content-center agreement agreement--borderMobile agreement--borderDashed">
                <b-col md="10" class="st_background_white pt-4 pt-md-5 px-4 pb-4 pb-md-5">
                  <b-row class="mb-4">
                    <b-col>
                      <h2 class="agreement__title text-center">
                        3.同意條款
                      </h2>
                    </b-col>
                  </b-row>
                  <b-row class="justify-content-center mt-md-3 mb-1 mb-md-3" noGutters>
                    <b-col cols="12" md="10">
                      <md-checkbox class="st-checkbox agreement__description" v-model="payAgree" :value="true">
                        我已詳閱並同意服務條款及付費政策，並理解若活動因故無法順利舉行，主辦方保有變更或終止本活動時間、內容之權力，將配合平台票券售後服務處理
                      </md-checkbox>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>

              <b-row class="action">
                <b-col
                  class="px-0 pt-4 pb-5 pt-md-5"
                  cols="12" offset-md="1" md="10">
                  <b-row class="mb-3 mb-md-5" v-if="event.refund">
                    <b-col cols="12" class="text-center st_caption-regular-small">
                      ＊此活動{{ event.refund === 'scantrader' ? '為官方退款' : '不接受退款' }}
                    </b-col>
                  </b-row>
                  <b-row class="mb-4 mb-md-5 pb-md-4">
                    <b-col cols="12" class="text-center mb-3">
                      <b-button
                        class="st_main_xl"
                        v-if="!isPayment"
                        @click.prevent="stepPaidInfoToPayment"
                        :disabled="!verificationAllPaidInfo">
                        確認並前往付款
                      </b-button>
                      <b-button class="st_main_xl d-flex align-items-center justify-content-center mx-auto" disabled v-else>
                        <md-progress-spinner :mdDiameter="16" :mdStroke="2" mdMode="indeterminate" /> 付款進行中...
                      </b-button>
                    </b-col>
                    <b-col cols="12" class="text-center">
                      <b-button
                        class="st_sub_xl"
                        v-if="!isPayment"
                        @click.prevent="cancelOrder">
                        取消報名
                      </b-button>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" class="text-center">
                      <h6 class="action__description">
                        確認付款後即代表您已同意
                        <b-link
                          class="st_color_link"
                          :to="{ name:'terms-of-service' }"
                          target="_blank">
                          服務條款
                        </b-link>
                        及
                        <b-link
                          class="st_color_link"
                          :to="{ name:'terms-of-pay' }"
                          target="_blank">
                          付款政策
                        </b-link>
                      </h6>
                    </b-col>
                  </b-row>

                  <b-row class="mt-5 pt-4 mt-md-2 justify-content-center align-items-center">
                    <span class="st_heading-light-smaller">合作金流</span>
                    <svg-icon class="mx-2" name="icon_linepay" width="70" height="20" />
                    <b-img class="action__tappay" src="images/png_icon/xxxhdpi/icon_tappay.png" alt="" fluid />
                  </b-row>
                </b-col>
              </b-row>
            </b-container>
            <b-container
              class="expiration"
              v-else-if="isExpired">
              <b-row class="justify-content-center text-center">
                <b-col
                  cols="11"
                  md="6"
                  class="expiration__content st_background_white">
                  <span class="st_main-medium-base d-inline-block mb-1 mb-md-0">本次訂購已逾期，請重新購票</span>
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-clock st_color_gray_light mr-1" />
                    <span class="expiration__content__timer">00:00:00</span>
                  </div>
                </b-col>
                <b-col cols="12">
                  <b-button
                    @click.prevent="reloadPage"
                    class="st_main_l d-block mx-auto mb-3 w-100 expiration__resubmit-button">
                    重新報名
                  </b-button>
                  <nuxt-link
                    class="st_main_l d-inline-block w-100 expiration__back"
                    to="">
                    返回探索活動
                  </nuxt-link>
                </b-col>
              </b-row>
            </b-container>
          </md-step>
          <md-step id="stepResult" :md-done.sync="done.stepResult" md-label="報名成功" :md-editable="false">
            <h3>報名成功</h3>
          </md-step>
        </md-steppers>
      </b-col>
      <b-col cols="12" class="text-center st_background_white" v-else>
        <i class="fa fa-spinner fa-spin my-5 st_none-none-biggest" />
      </b-col>
    </b-row>

    <EventPageLoginModel
      v-if="!user.serial" />

    <EventPageDeniedModal
      @hidePopup="deniedModalShow = false"
      v-if="deniedModalShow" />

    <div class="ecpay_html" ref="ecpay_html" v-show="false" v-html="ecpayHtml" />
  </b-container>
</template>

<script>
  import EventPageDeniedModal from '~/components/modal/EventPageDeniedModal'
  import EventPageLoginModel from '~/components/modal/EventPageLoginModal'
  import Input from '~/components/forms/Input'
  import { mapActions, mapGetters, mapState } from 'vuex'

  const demoEvent = {
    type:         'event',
    id:           '016a4de781460000298d000000000000',
    period:       { start: 1556672400000, end: 1556793000000 },
    cover:        'https://storage.googleapis.com/quants-images/scantrader/upload/016a4e2084d30000298d000000000000.png',
    description:  '從了解趨勢，到掌握交易，Francis Tou 將帶給您正確的加密貨幣觀念，並從 K 線解析趨勢，輕鬆掌握多變又迷人的加密貨幣市場，最後我們將邀請 BitAsset 首席顧問，現場與您一同頗析加密貨幣交易所該如何抉擇從了解趨勢，到掌握交易，Francis Tou 將帶給您正確的加密貨幣觀念，並從 K 線解析趨勢，輕鬆掌握多變又迷人的加密貨幣市場',
    introduction: null,
    refund:       'none',
    title:        '比特幣的瘋狂與絕望 K 線解析趨勢， 輕鬆掌握多變又迷人的加密貨幣市場',
    account:      { identity: '01641d0118800000424d000000000000', name: { nick: '我是超強的達人', real: 'Tsai. Wen-Sheng' }, serial: 1 },
    contact:      {
      phone: '0212345678', email: 'service@scantrader.com', lineAt: 'https://line.me/R/ti/p/@u168', fbFanPage: 'https://www.facebook.com/u168.tw/',
    },
    kind:     'offline',
    identity: '016a4de781460000298d000000000000',
  }
  const demoProducts = [{
    type:                 'product',
    id:                   '016ac4c5bb5900002267000000000000',
    buyPeriod:            { start: 1556640000000, end: 1561824000000 },
    buyConditions:        { channel: { type: 'all', list: [] }, event: { type: 'all', list: [] }, operator: 'all' },
    unavailableBuyOption: { paymentMethod: ['LINEPAY/NORMAL'] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '不能用LINEPAY',
    price:                1200,
    identity:             '016ac4c5bb5900002267000000000000',
    purchases:            0,
  }, {
    type:          'product',
    id:            '016ac3e23b8400007e2d000000000000',
    buyPeriod:     { start: 1556640000000, end: 1561824000000 },
    buyConditions: {
      operator: 'channel||event',
      event:    { type: 'whitelist', list: ['016a95adb93500007c90000000000000', '016a95c127d100007c90000000000000'] },
      channel:  { type: 'whitelist', list: ['0164b16b53d500004d18000000000000', '016980bd8190000047d5000000000000'] },
    },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '限活動或訂閱者票',
    price:                1200,
    identity:             '016ac3e23b8400007e2d000000000000',
    purchases:            0,
  }, {
    type:          'product',
    id:            '016ac3e2067500007e2d000000000000',
    buyPeriod:     { start: 1556640000000, end: 1561824000000 },
    buyConditions: {
      operator: 'channel&&event',
      event:    { type: 'whitelist', list: ['016a95adb93500007c90000000000000', '016a95c127d100007c90000000000000'] },
      channel:  { type: 'whitelist', list: ['0164b16b53d500004d18000000000000', '016980bd8190000047d5000000000000'] },
    },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '限活動及訂閱者票',
    price:                1200,
    identity:             '016ac3e2067500007e2d000000000000',
    purchases:            0,
  }, {
    type:          'product',
    id:            '016ac3e0718f00007e2d000000000000',
    buyPeriod:     { start: 1556640000000, end: 1561824000000 },
    buyConditions: {
      operator: 'channel&&event',
      event:    { type: 'whitelist', list: ['016a95adb93500007c90000000000000', '016a95c127d100007c90000000000000'] },
      channel:  { type: 'atLeastOne', list: [] },
    },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '限活動及全部訂閱者票',
    price:                1200,
    identity:             '016ac3e0718f00007e2d000000000000',
    purchases:            0,
  }, {
    type:          'product',
    id:            '016ac3e02bfa00007e2d000000000000',
    buyPeriod:     { start: 1556640000000, end: 1561824000000 },
    buyConditions: {
      operator: 'channel||event',
      event:    { type: 'whitelist', list: ['016a95adb93500007c90000000000000', '016a95c127d100007c90000000000000'] },
      channel:  { type: 'atLeastOne', list: [] },
    },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '限活動或全部訂閱者票',
    price:                1200,
    identity:             '016ac3e02bfa00007e2d000000000000',
    purchases:            1,
  }, {
    type:          'product',
    id:            '016ac3dfac3400007e2d000000000000',
    buyPeriod:     { start: 1556640000000, end: 1561824000000 },
    buyConditions: {
      operator: 'channel||event',
      event:    { type: 'whitelist', list: ['016a95adb93500007c90000000000000', '016a95c127d100007c90000000000000'] },
      channel:  { type: 'all', list: [] },
    },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '限活動票',
    price:                1200,
    identity:             '016ac3dfac3400007e2d000000000000',
    purchases:            0,
  }, {
    type:                 'product',
    id:                   '016ac3bcde8e00007e2d000000000000',
    buyPeriod:            { start: 1556640000000, end: 1561824000000 },
    buyConditions:        { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '完售票',
    price:                13333,
    identity:             '016ac3bcde8e00007e2d000000000000',
    purchases:            1,
  }, {
    type:                 'product',
    id:                   '016ac3bbdfc000007e2d000000000000',
    buyPeriod:            { start: 1559318400000, end: 1561824000000 },
    buyConditions:        { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '未開放票',
    price:                13333,
    identity:             '016ac3bbdfc000007e2d000000000000',
    purchases:            0,
  }, {
    type:                 'product',
    id:                   '016ac3b9b45100007e2d000000000000',
    buyPeriod:            { start: 1546272000000, end: 1558972800000 },
    buyConditions:        { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    unavailableBuyOption: { paymentMethod: [] },
    maximum:              -1,
    content:              '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:              false,
    detail:               { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:                 'ticket',
    title:                '一般票2',
    price:                999,
    identity:             '016ac3b9b45100007e2d000000000000',
    purchases:            1,
  }, {
    type:          'product',
    id:            '016a535a91eb00006518000000000000',
    buyPeriod:     { start: 1546272000000, end: 1558972800000 },
    buyConditions: { operator: 'channel||event', event: { type: 'all', list: [] }, channel: { type: 'atLeastOne', list: [] } },
    maximum:       50,
    content:       '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:       false,
    detail:        { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:          'ticket',
    title:         '全部訂閱者',
    price:         400,
    identity:      '016a535a91eb00006518000000000000',
    purchases:     0,
  }, {
    type:          'product',
    id:            '016a5359cb4000006518000000000000',
    buyPeriod:     { start: 1546272000000, end: 1558972800000 },
    buyConditions: {
      operator: 'channel||event',
      event:    { type: 'all', list: [] },
      channel:  { type: 'whitelist', list: ['01694bf8f4e800006b2f000000000000', '0169513a0a4a0000391f000000000000'] },
    },
    maximum:   100,
    content:   '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:   false,
    detail:    { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:      'ticket',
    title:     '限訂閱者',
    price:     300,
    identity:  '016a5359cb4000006518000000000000',
    purchases: 0,
  }, {
    type:          'product',
    id:            '016a4e20837d0000298d000000000000',
    buyPeriod:     { start: 1546272000000, end: 1548950340000 },
    buyConditions: { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    maximum:       10,
    content:       '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:       false,
    detail:        { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:          'ticket',
    title:         '過期票',
    price:         10000,
    identity:      '016a4e20837d0000298d000000000000',
    purchases:     0,
  }, {
    type:          'product',
    id:            '016a4e2083770000298d000000000000',
    buyPeriod:     { start: 1546272000000, end: 1548950340000 },
    buyConditions: { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    maximum:       100,
    content:       '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:       false,
    detail:        { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:          'ticket',
    title:         '早鳥票',
    price:         750,
    identity:      '016a4e2083770000298d000000000000',
    purchases:     0,
  }, {
    type:          'product',
    id:            '016a4e2083660000298d000000000000',
    buyPeriod:     { start: 1546272000000, end: 1558972800000 },
    buyConditions: { operator: 'all', event: { type: 'all', list: [] }, channel: { type: 'all', list: [] } },
    maximum:       -1,
    content:       '\t1.\t購買後即代表您可使用 1 個持股清單參賽。\n\t2.\t購買後則等於您將參與本期競賽，且報名費不可退款。\n\t3.\t於競賽開始前兩個月開放早鳥報名，優惠為一個月可享有9折票價優惠。',
    drafted:       false,
    detail:        { usePeriod: { start: 1554048000000, end: 1559145600000 }, kind: 'event', event: '016a4de781460000298d000000000000' },
    kind:          'ticket',
    title:         '一般票',
    price:         1280,
    identity:      '016a4e2083660000298d000000000000',
    purchases:     5,
  }]
  export default {
    components: {
      Input,
      EventPageLoginModel,
      EventPageDeniedModal,
    },
    async asyncData ({
      store, query, params, redirect,
    }) {
      let event = await store.dispatch('api/event/getEvent', {
        identity: params.eid,
        drafted:  false,
        fields:   ['identity', 'kind', 'cover', 'account.identity', 'account.name', 'account.serial', 'title', 'description', 'introduction', 'contact', 'period', 'refund'],
      })
      if (typeof query.demo !== 'undefined') {
        event = demoEvent
      }
      if (event.error) {
        return redirect({ name: 'event-eid', params })
      }
      let products = await store.dispatch('api/product/getProducts', {
        detailEvent: event.identity,
      })
      if (typeof query.demo !== 'undefined') {
        products = { data: demoProducts }
      }
      if (products.error) {
        return redirect({ name: 'event-eid', params })
      }
      return {
        event,
        products: products.data,
      }
    },
    filters: {
      twoDigits (value) {
        if (value.toString().length <= 1) {
          return `0${value.toString()}`
        }
        return value.toString()
      },
    },
    head () {
      return {
        title: `${this.event.title || ''
        } - 活動報名`,
        meta: [
          {
            hid:     'title',
            name:    'title',
            content: `${this.event.title || ''
            } - 活動報名`,
          },
          {
            hid:      'og:title',
            property: 'og:title',
            content:  `${this.event.title || ''
            } - 活動報名`,
          },
          {
            hid:     'description',
            name:    'description',
            content: this.event.description || '',
          },
          {
            hid:      'og:description',
            property: 'og:description',
            content:  this.event.description || '',
          },
          {
            hid:     'image',
            name:    'image',
            content: this.event.cover || null,
          },
          {
            hid:      'og:image',
            property: 'og:image',
            content:  this.event.cover || null,
          },
        ],
      }
    },
    data () {
      return {
        loaded: false,
        step:   'stepSelect',
        done:   {
          stepSelect:   false,
          stepUserInfo: false,
          stepPaidInfo: false,
          stepResult:   false,
        },
        event:                null,
        products:             [],
        events:               [],
        channels:             [],
        selectProducts:       [],
        userInfo:             [],
        pay:                  'LINEPAY/NORMAL',
        payTappay:            '',
        order:                null,
        buttonLoading:        false,
        expired:              null,
        orderTimer:           null,
        verificationFeedback: {
          name:      '格式或字數不符',
          email:     '電子郵件格式錯誤',
          phone:     '請填寫正確的聯絡電話',
          companyId: {
            type:       '公司編號僅能輸入數字',
            limitation: '字數不符',
          },
          companyName: '格式或字數不符',
        },
        formData: {
          accType:     '1',
          name:        null,
          phone:       null,
          email:       null,
          companyName: null,
          companyId:   null,
        },
        payAgree:  false,
        ecpayHtml: '',
        card:      {
          type:   'none',
          number: '',
          expiry: '',
          ccv:    '',
        },
        cards:           null,
        useNewCard:      true,
        paymentCard:     null,
        isPayment:       false,
        deniedModalShow: false,
        isExpired:       false,
        expiredArea:     'none',
      }
    },
    computed: {
      ...mapState(['setting']),
      ...mapGetters(['user', 'siteSetting']),
      verificationAllUserInfo () {
        let result = false
        if (this.order
          && this.order.purchases
          && this.order.purchases.length
        ) {
          result = true
          this.order.purchases.forEach(purchase => {
            if (!this.verificationName(purchase.detail.userInfo.name) || !this.verificationPhone(purchase.detail.userInfo.phone) || !this.verificationEmail(purchase.detail.userInfo.email)) {
              result = false
            }
          })
        }
        return result
      },
      payment () {
        return this.pay.split('/')[0]
      },
      payType () {
        return this.pay.split('/')[1]
      },
      payFee () {
        return (this.order && this.order.priceTable && this.order.priceTable[(this.pay === 'TAPPAY/CREDIT' && this.payTappay !== '') ? `${this.pay}_${this.payTappay}` : this.pay].fee) || 0
      },
      payPrice () {
        return (this.order && this.order.priceTable && this.order.priceTable[(this.pay === 'TAPPAY/CREDIT' && this.payTappay !== '') ? `${this.pay}_${this.payTappay}` : this.pay].total) || 0
      },
      verificationAllPaidInfo () {
        if (!this.useNewCard && !this.paymentCard) {
          return false
        }
        if (this.payment === 'TAPPAY' && this.useNewCard) {
          if (!this.cardNumberState || !this.cardExpiryState || !this.cardCcvState) {
            return false
          }
        }
        if (!this.payAgree) {
          return false
        }
        if (this.formData.accType === '1') {
          return this.verificationName(this.formData.name) && this.verificationPhone(this.formData.phone) && this.verificationEmail(this.formData.email)
        } else if (this.formData.accType === '2') {
          return this.verificationCompanyName(this.formData.companyName) && this.verificationCompanyId(this.formData.companyId) && this.verificationPhone(this.formData.phone) && this.verificationEmail(this.formData.email)
        }
        return false
      },
      cardNumber () {
        let number = ''
        if (
          this.card.type !== 'none'
          && (
            (this.card.type === 'amex' && this.card.number.length === 18)
            || (this.card.type !== 'amex' && this.card.number.length === 19)
          )
        ) {
          number = this.card.number.split('-').join('')
        }
        return number
      },
      cardMonth () {
        let month = ''
        if (this.card.expiry !== '' && this.card.expiry.length > 1) {
          month = this.card.expiry.split('/')[0]
        }
        return month
      },
      cardYear () {
        let year = ''
        if (this.card.expiry !== '' && this.card.expiry.length > 4) {
          year = this.card.expiry.split('/')[1]
        }
        return year
      },
      cardNumberState () {
        let state = null
        if (this.cardNumber !== '') {
          const type = TPDirect.validate.cardType(this.cardNumber)
          state = TPDirect.validate.cardNumber(this.cardNumber, type)
        }
        return state
      },
      cardExpiryState () {
        let state = null
        if (this.cardMonth !== '' && this.cardYear !== '') {
          state = TPDirect.validate.expiry(this.cardMonth, this.cardYear)
        }
        return state
      },
      cardCcvState () {
        let state = null
        if (this.cardNumber !== '' && this.card.ccv !== '') {
          const type = TPDirect.validate.cardType(this.cardNumber)
          if ((type === 'AMEX' && this.card.ccv.length === 4) || (type !== 'AMEX' && this.card.ccv.length === 3)) {
            state = TPDirect.validate.ccv(this.card.ccv, type)
          }
        } else if (this.cardNumber === '' && this.card.ccv.length === 3) {
          state = false
        }
        return state
      },
      cardListLinePay () {
        const cards = null
        if (this.cards && this.cards.length) {
          return this.cards.filter(card => card.payment === 'LINEPAY')
        }
        return cards
      },
      cardListTapPay () {
        const cards = null
        if (this.cards && this.cards.length) {
          return this.cards.filter(card => card.payment === 'TAPPAY')
        }
        return cards
      },
    },
    watch: {
      'formData.name':    'replaceAllEmoji',
      'formData.tel':     'replaceAllEmoji',
      'formData.email':   'replaceAllEmoji',
      'formData.comName': 'replaceAllEmoji',
      'formData.comId':   'replaceAllEmoji',
      useNewCard:         'revertUseNewCard',
      pay:                'revertCard',
      'card.number':      'replaceCardNumber',
      'card.expiry':      'replaceCardExpiry',
      'card.ccv':         'replaceCardCcv',
    },
    methods: {
      ...mapActions('api/channel', ['getChannels']),
      ...mapActions('api/event', ['getEvents']),
      ...mapActions('api/card', ['getCards']),
      ...mapActions('api/order', ['getOrderProduct', 'getUserOrdersProduct', 'createOrderProductPreOrder', 'cancelProductOrders', 'updateOrderProductInfo', 'createOrderProduct']),
      changeStepperHeight () {
        if (this.$refs.step) {
          this.$refs.step.calculateStepperPos()
        }
      },
      async loadCardList () {
        this.cards = null
        const option = {
          isValid:   true,
          accountId: this.user.my_info.identity,
        }
        await this.getCards(option).then(data => {
          if (!data.error) {
            this.cards = data.cards
          }
        })
      },
      getChannelByIdentity (identity) {
        let returnChannel = null
        if (this.channels.length) {
          returnChannel = this.channels.find(channel => channel.identity === identity) || null
        }
        return returnChannel
      },
      getEventByIdentity (identity) {
        let returnEvent = null
        if (this.events.length) {
          returnEvent = this.events.find(event => event.identity === identity) || null
        }
        return returnEvent
      },
      checkProductStarted (product) {
        return this.$moment().valueOf() > product.buyPeriod.start
      },
      checkProductEnded (product) {
        return this.$moment().valueOf() > product.buyPeriod.end
      },
      checkProductFulled (product) {
        return !!(product.maximum > 0 && (product.purchases || 0) >= product.maximum)
      },
      checkProductDisable (product) {
        return !this.checkProductStarted(product) || this.checkProductEnded(product) || this.checkProductFulled(product)
      },
      checkProductNeedOr (product) {
        return !!(product.buyConditions && product.buyConditions.operator === 'channel||event' && product.buyConditions.channel.type !== 'all' && product.buyConditions.event.type !== 'all')
      },
      stepSelectToUserInfo () {
        if (this.user.serial === 0 || this.selectProducts.length === 0) return
        this.buttonLoading = true
        const orderOption = {
          AccountId: this.user.my_info.identity,
          kind:      'event',
          index:     this.event.identity,
          carts:     this.selectProducts.map(product => ({
            product:  product,
            quantity: 1,
          })),
        }
        this.createOrderProductPreOrder(orderOption).then(data => {
          if (data.error) {
            this.deniedModalShow = true
          } else {
            this.$router.push({
              query: { order: data.identity },
            })
            this.order = {
              identity:  data.identity,
              kind:      data.kind,
              index:     data.index,
              state:     data.state,
              carts:     data.carts,
              purchases: data.purchases.map(purchase => {
                Object.keys(purchase.detail.userInfo).forEach(userInfoKey => {
                  purchase.detail.userInfo[userInfoKey] = purchase.detail.userInfo[userInfoKey] || ''
                })
                return {
                  identity: purchase.identity,
                  detail:   {
                    userInfo: purchase.detail.userInfo,
                  },
                  product: {
                    identity: purchase.product,
                    title:    data.carts.find(product => product.product === purchase.product).title,
                    price:    data.carts.find(product => product.product === purchase.product).price,
                  },
                }
              }),
              unavailableBuyOption: data.unavailableBuyOption,
            }
            this.expired = data.expired
            this.done.stepSelect = true
            this.step = 'stepUserInfo'
            this.calcCountDownTime('userInfo')
          }
          this.buttonLoading = false
        })
      },
      cancelOrder () {
        const option = {
          identity: this.order.identity,
        }
        this.cancelProductOrders(option).then(this.reloadPage)
      },
      reloadPage () {
        this.$router.replace({ name: this.$route.name, params: this.$route.params }, () => {
          this.$router.go(0)
        })
      },
      async calcCountDownTime (area) {
        if (this.order && this.expired && !process.server) {
          const diffSecond = this.$moment(this.expired).diff(this.$moment(), 'second')
          this.$set(this, 'orderTimer', diffSecond > 0 ? {
            hour:   Math.trunc(diffSecond / 60 / 60),
            minute: Math.trunc(diffSecond / 60) % 60,
            second: Math.trunc(diffSecond) % 60,
          } : null)
          if (diffSecond > 0) {
            await this.$nextTick()
            if (area) {
              this.expiredArea = area
              switch (area) {
                case 'userInfo':
                  this.$refs.step.$el.querySelectorAll('button.md-stepper-header')[1].querySelector('.md-button-content').append(this.$refs.orderTimer)
                  break
                case 'paidInfo':
                  this.$refs.step.$el.querySelectorAll('button.md-stepper-header')[2].querySelector('.md-button-content').append(this.$refs.orderTimer)
                  break
                default:
                  break
              }
            }
            setTimeout(this.calcCountDownTime, 1000)
          } else {
            if (this.$refs.step.$el.querySelector('.stepTimer')) this.$refs.step.$el.querySelector('.stepTimer').remove()
            this.isExpired = true
          }
        }
      },
      verificationName (name, ignoreEmpty = false) {
        this.changeStepperHeight()
        if (ignoreEmpty && (!name || name.length === 0)) {
          return true
        }
        return name && !!(name.length)
      },
      verificationEmail (email, ignoreEmpty = false) {
        this.changeStepperHeight()
        if (ignoreEmpty && (!email || email.length === 0)) {
          return true
        }
        const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return email && email.length && emailRegex.test(email)
      },
      verificationPhone (phone, ignoreEmpty = false) {
        this.changeStepperHeight()
        if (ignoreEmpty && (!phone || phone.length === 0)) {
          return true
        }
        const phoneRegex = /^\d{7,}$/
        return phone && phone.length && phoneRegex.test(phone)
      },
      verificationCompanyId (companyId, ignoreEmpty = false, verifyType = false) {
        this.changeStepperHeight()
        if (ignoreEmpty && (!companyId || companyId.length === 0)) {
          return true
        }
        const companyIdRegex = verifyType ? /^\d+$/ : /^\d{8}$/
        return companyId && companyId.length && companyIdRegex.test(companyId)
      },
      verificationCompanyName (name, ignoreEmpty = false) {
        this.changeStepperHeight()
        if (ignoreEmpty && (!name || name.length === 0)) {
          return true
        }
        return name && !!(name.length)
      },
      stepUserInfoToPaidInfo () {
        this.buttonLoading = true
        const userInfoOption = {
          account:       this.user.my_info.identity,
          order:         this.order.identity,
          purchaseInfos: this.order.purchases.map(purchase => ({
            identity: purchase.identity,
            detail:   purchase.detail,
          })),
        }
        this.updateOrderProductInfo(userInfoOption).then(data => {
          if (data.error) {
            this.$toast.show('報名資料儲存錯誤').goAway(5000)
          } else {
            if (data.state && data.state === 'paidInfo') {
              this.order.state = data.state
              this.$set(this.order, 'priceTable', data.priceTable)
              this.expired = data.expired
              if (this.checkPayDisable(this.pay)) {
                this.pay = [
                  'LINEPAY/NORMAL',
                  'TAPPAY/CREDIT',
                  'ECPAY/ATM',
                  'ECPAY/CVS',
                ].find(pay => !this.checkPayDisable(pay))
              }
              this.revertCard()
              this.done.stepUserInfo = true
              this.step = 'stepPaidInfo'
              this.calcCountDownTime('paidInfo')
            } else {
              this.$router.push({
                name:   'event-eid-register-oid',
                params: {
                  eid: this.$route.params.eid,
                  oid: data.identity,
                },
              })
            }
            this.order.state = data.state
            this.$set(this.order, 'priceTable', data.priceTable)
            this.expired = data.expired
            if (this.checkPayDisable(this.pay)) {
              this.pay = [
                'LINEPAY/NORMAL',
                'TAPPAY/CREDIT',
                'ECPAY/ATM',
                'ECPAY/CVS',
              ].find(pay => !this.checkPayDisable(pay))
            }
            this.revertCard()
            this.done.stepUserInfo = true
            this.step = 'stepPaidInfo'
            this.calcCountDownTime('paidInfo')
            this.$scrollTo('.md-steppers-navigation')
          }
          this.buttonLoading = false
        })
      },
      checkPayDisable (payment) {
        if (this.order && this.order.unavailableBuyOption && this.order.unavailableBuyOption.paymentMethod && this.order.unavailableBuyOption.paymentMethod.length) {
          return this.order.unavailableBuyOption.paymentMethod.includes(payment)
        }
        return false
      },
      revertUseNewCard () {
        this.paymentCard = null
      },
      revertCard () {
        this.paymentCard = null
        this.useNewCard = true
        switch (this.payment) {
          case 'LINEPAY':
            if (this.cardListLinePay && this.cardListLinePay.length) {
              this.useNewCard = false
            }
            break
          case 'TAPPAY':
            if (this.cardListTapPay && this.cardListTapPay.length) {
              this.useNewCard = false
            }
            break
        }
      },
      replaceAllEmoji () {
        this.formData.name = this.formData.name === null ? this.formData.name : this.$utils.replaceEmoji(this.formData.name)
        this.formData.phone = this.formData.phone === null ? this.formData.phone : this.$utils.replaceEmoji(this.formData.phone)
        this.formData.email = this.formData.email === null ? this.formData.email : this.$utils.replaceEmoji(this.formData.email)
        this.formData.companyName = this.formData.companyName === null ? this.formData.companyName : this.$utils.replaceEmoji(this.formData.companyName).replace(' ', '')
        this.formData.companyId = this.formData.companyId === null ? this.formData.companyId : this.$utils.replaceEmoji(this.formData.companyId).replace(' ', '')
      },
      replaceCardNumber () {
        if (this.card.number !== '') {
          const number = this.card.number.split('-').join('').replace(/[^0-9.]/g, '') || ''
          let type = 'none'
          switch (TPDirect.validate.cardType(number)) {
            case 'VISA':
              type = 'visa'
              break
            case 'MASTERCARD':
              type = 'master'
              break
            case 'JCB':
              type = 'jcb'
              break
            case 'AMEX':
              type = 'amex'
              break
          }
          this.card.type = type
          if (type === 'amex') {
            const numberSplit = number.split('')
            if (numberSplit[11]) {
              numberSplit.splice(11, 0, '-')
            }
            if (numberSplit[5]) {
              numberSplit.splice(5, 0, '-')
            }
            this.card.number = numberSplit.join('')
          } else {
            this.card.number = (number.match(/.{1,4}/g) || []).join('-')
          }
        } else {
          this.card.type = 'none'
        }
      },
      replaceCardExpiry () {
        if (this.card.expiry && this.card.expiry !== '') {
          let expiry = this.card.expiry.split('/').join('').replace(/[^0-9.]/g, '') || ''
          if (this.card.expiry.length === 2 && this.cardMonth > 12) {
            expiry = `0${this.card.expiry}`
          }
          if (expiry.length > 2) {
            expiry = expiry.match(/.{1,2}/g).join('/')
          }
          this.card.expiry = expiry || null
        }
      },
      replaceCardCcv () {
        this.card.ccv = this.card.ccv.replace(/[^0-9.]/g, '') || ''
      },
      getCardType (cardType) {
        let type = 'none'
        switch (cardType) {
          case 'VISA':
            type = 'visa'
            break
          case 'MASTER':
            type = 'master'
            break
          case 'JCB':
            type = 'jcb'
            break
          case 'AMEX':
            type = 'amex'
            break
        }
        return type
      },
      stepPaidInfoToPayment () {
        this.buttonLoading = true
        this.isPayment = true
        this.ecpayHtml = ''
        const { protocol } = window.location
        const domain = window.location.href.split('/')[2]
        const callback = `${protocol}//${domain}${process.env.basePath}event/${this.event.identity}/register/${this.order.identity}`

        const order = {
          payment:      this.payment,
          payType:      this.payType + ((this.pay === 'TAPPAY/CREDIT' && this.payTappay !== '') ? (`_${this.payTappay}`) : ''),
          order:        this.order.identity,
          AccountId:    this.user.my_info.identity,
          callback:     callback,
          contactEmail: this.formData.email,
          contactPhone: this.formData.phone,
        }

        // 判斷個人訂單還是公司訂單
        if (this.formData.accType === '1') {
          order.realName = this.formData.name
        } else {
          order.companyName = this.formData.companyName
          order.taxId = this.formData.companyId
        }

        const useCardCheck = !!(!this.useNewCard && (this.payment === 'LINEPAY' || this.payment === 'TAPPAY') && this.paymentCard)
        if (useCardCheck) {
          order.cardId = this.paymentCard.id
        }

        if (this.pay === 'TAPPAY/CREDIT' && this.useNewCard) {
          TPDirect.card.createToken(this.cardNumber, this.cardMonth, this.cardYear, this.card.ccv, res => {
            if (res.status === 0) {
              order.prime = res.card.prime
              this.createOrderProduct(order).then(data => {
                if (!data.error) {
                  if (data.url) {
                    window.location.href = data.url
                  } else if (data.confirmResult) {
                    window.location.href = data.confirmResult.data.payment_url
                  } else {
                    this.isPayment = false
                    this.buttonLoading = false
                    this.$bvModal.msgBoxOk('信用卡付款錯誤，請洽客服人員', {
                      size:            'sm',
                      buttonSize:      'sm',
                      okVariant:       'success',
                      okTitle:         '確定',
                      footerClass:     'p-2 border-0',
                      hideHeaderClose: false,
                      centered:        true,
                    })
                  }
                } else {
                  this.isPayment = false
                  this.buttonLoading = false

                  this.$bvModal.msgBoxOk('信用卡付款錯誤，請洽客服人員', {
                    size:            'sm',
                    buttonSize:      'sm',
                    okVariant:       'success',
                    okTitle:         '確定',
                    footerClass:     'p-2 border-0',
                    hideHeaderClose: false,
                    centered:        true,
                  })
                }
              })
            } else {
              this.isPayment = false
              this.buttonLoading = false
              this.$bvModal.msgBoxOk('信用卡付款錯誤，請洽客服人員', {
                size:            'sm',
                buttonSize:      'sm',
                okVariant:       'success',
                okTitle:         '確定',
                footerClass:     'p-2 border-0',
                hideHeaderClose: false,
                centered:        true,
              })
            }
          })
        } else {
          this.createOrderProduct(order).then(data => {
            if (useCardCheck) {
              if (data.url) {
                window.location.href = data.url
              } else if (data.confirmResult) {
                window.location.href = data.confirmResult.data.payment_url
              } else {
                this.isPayment = false
                this.buttonLoading = false
                this.$bvModal.msgBoxOk('卡片付款錯誤，請洽客服人員', {
                  size:            'sm',
                  buttonSize:      'sm',
                  okVariant:       'success',
                  okTitle:         '確定',
                  footerClass:     'p-2 border-0',
                  hideHeaderClose: false,
                  centered:        true,
                })
              }
            } else {
              switch (this.payment) {
                case 'LINEPAY':
                  if (data.linePayResult.returnCode !== '0000') {
                    this.isPayment = false
                    this.buttonLoading = false
                    this.$bvModal.msgBoxOk('LINE Pay 錯誤，請洽客服人員', {
                      size:            'sm',
                      buttonSize:      'sm',
                      okVariant:       'success',
                      okTitle:         '確定',
                      footerClass:     'p-2 border-0',
                      hideHeaderClose: false,
                      centered:        true,
                    })
                  } else {
                    window.location.href = data.linePayResult.info.paymentUrl.web
                  }
                  break
                case 'ECPAY':
                  if (!data.error) {
                    this.ecpayHtml = data.ecpayResult
                    const checkEcpayForm = setInterval(() => {
                      const form = this.$refs.ecpay_html.getElementsByTagName('form')
                      if (form.length > 0) {
                        clearInterval(checkEcpayForm)
                        form[0].submit()
                      }
                    }, 100)
                  } else {
                    this.isPayment = false
                    this.buttonLoading = false
                    this.$bvModal.msgBoxOk('EC Pay 錯誤，請洽客服人員', {
                      size:            'sm',
                      buttonSize:      'sm',
                      okVariant:       'success',
                      okTitle:         '確定',
                      footerClass:     'p-2 border-0',
                      hideHeaderClose: false,
                      centered:        true,
                    })
                  }
                  break
              }
            }
          })
        }
      },
      showToast (product) {
        if (!this.checkProductStarted(product)) {
          this.$toast.show('尚未開放售票').goAway(3000)
        } else if (this.checkProductStarted(product) && this.checkProductFulled(product)) {
          this.$toast.show('票種已完售').goAway(3000)
        } else if (this.checkProductStarted(product) && !this.checkProductFulled(product) && this.checkProductEnded(product)) {
          this.$toast.show('此票種已結束售票').goAway(3000)
        }
      },
      copyPreviousPurchaseUserInfo (purchaseIndex) {
        const purchase = this.order.purchases[purchaseIndex]
        const previousPurchase = this.order.purchases[purchaseIndex - 1]
        purchase.detail.userInfo = _.cloneDeep(previousPurchase.detail.userInfo)
      },
      setOrder (data) {
        if (!data || !data.state || !['userInfo', 'paidInfo'].includes(data.state)) {
          return false
        }
        if (!data.expired || this.$moment().valueOf() > data.expired) {
          this.reloadPage()
          return false
        }
        this.$set(this, 'expired', data.expired)
        const order = {
          identity:  data.identity,
          kind:      data.kind,
          index:     data.index,
          state:     data.state,
          carts:     data.carts,
          purchases: data.purchases.map(purchase => {
            Object.keys(purchase.detail.userInfo).forEach(userInfoKey => {
              purchase.detail.userInfo[userInfoKey] = purchase.detail.userInfo[userInfoKey] || ''
            })
            return {
              identity: purchase.identity,
              detail:   {
                userInfo: purchase.detail.userInfo,
              },
              product: purchase.product,
            }
          }),
          unavailableBuyOption: data.unavailableBuyOption,
          priceTable:           data.priceTable,
        }
        this.$set(this, 'order', order)
        switch (order.state) {
          case 'userInfo':
            this.done.stepSelect = true
            this.step = 'stepUserInfo'
            break
          case 'paidInfo':
            if (this.checkPayDisable(this.pay)) {
              this.pay = [
                'LINEPAY/NORMAL',
                'TAPPAY/CREDIT',
                'ECPAY/ATM',
                'ECPAY/CVS',
              ].find(pay => !this.checkPayDisable(pay))
            }
            this.revertCard()
            this.done.stepSelect = true
            this.done.stepUserInfo = true
            this.step = 'stepPaidInfo'
            break
        }
        return true
      },
    },
    async created () {
      if (this.products.length) {
        const channels = []
        const events = []
        this.products.forEach(product => {
          if (product.buyConditions.operator && product.buyConditions.operator !== 'all') {
            if (product.buyConditions.channel.type === 'whitelist' && product.buyConditions.channel.list.length) {
              channels.push(...product.buyConditions.channel.list)
            }
            if (product.buyConditions.event.type === 'whitelist' && product.buyConditions.event.list.length) {
              events.push(...product.buyConditions.event.list)
            }
          }
        })
        if (channels.length) {
          const channelsOption = {
            fields:   ['identity', 'title', 'account.identity', 'account.serial'],
            identity: channels,
          }
          this.getChannels(channelsOption).then(data => {
            if (!data.error) {
              this.channels = data.data
            }
          })
        }
        if (events.length) {
          const eventsOption = {
            fields:   ['identity', 'title', 'account.identity', 'account.serial'],
            identity: events,
          }
          this.getEvents(eventsOption).then(data => {
            if (!data.error) {
              this.events = data.data
            }
          })
        }
      }
      if (this.user.serial !== 0) {
        this.loadCardList()
        if (this.$route.query.order) {
          await this.getOrderProduct(this.$route.query.order).then(data => {
            if (data && !data.error && data.state && ['userInfo', 'paidInfo', 'pending', 'paid', 'error'].includes(data.state)) {
              if (['userInfo', 'paidInfo'].includes(data.state)) {
                this.setOrder(data)
              } else {
                this.$router.push({
                  name:   'event-eid-register-oid',
                  params: {
                    eid: this.$route.params.eid,
                    oid: data.identity,
                  },
                })
              }
              return false
            }
            this.reloadPage()
            return false
          })
        }
        if (!this.order) {
          const option = {
            accountIds: this.user.my_info.identity,
            state:      'userInfo,paidInfo',
            event:      this.event.identity,
          }
          await this.getUserOrdersProduct(option).then(async data => {
            if (data && !data.error && data.length) {
              const order = data[0]
              order.priceTable = await this.getOrderProduct(order.identity).then(data => data.priceTable)
              this.setOrder(order)
              this.$router.push({
                name:   'event-eid-register',
                params: {
                  eid: this.$route.params.eid,
                },
                query: {
                  order: order.identity,
                },
              })
            }
          })
        }
      }
      this.loaded = true
      if (this.order && this.order.state) {
        await this.$nextTick()
        this.calcCountDownTime(this.order.state)
      }
    },
    mounted () {
      if (this.siteSetting.TPDirect && TPDirect && !TPDirect.appID) {
        TPDirect.setupSDK(this.siteSetting.TPDirect.appID, this.siteSetting.TPDirect.appIDappKey, this.siteSetting.TPDirect.serverType)
      }
    },
    destroyed () {
      this.order = null
      this.expired = null
    },
  }
</script>

<style lang="scss" scoped>
.event-image {
  padding-bottom: 35%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }
}

.container {
  &--width {
    @include media-breakpoint-down(sm) {
      max-width: 100%;
    }
  }

  &--stepTimer {
    @include media-breakpoint-down(sm) {
      padding-top: 29px;
    }
  }
}

.stepTimer {
  position: fixed;
  z-index: 1001;
  top: 50px;
  left: 0;
  width: 100%;
  background-color: $st_color_white;

  @include media-breakpoint-up(md) {
    position: absolute;
    bottom: -110%;
    top: auto;
    left: auto;
    width: auto;
    text-align: center;
    margin-left: calc(50% - 90px);
    line-height: $st_font-line-height-small;
    background-color: $st_color_transparent;
  }

  &__block {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__prefix,
  &__suffix {
    color: $st_color_gray_dark;
    font-size: $st_font-size-small;
    display: inline-block;
  }

  &__icon {
    font-size: $st_font-size-base;
    padding-right: 8px;
    opacity: 0.5;
  }

  &__time {
    color: #ff9425;
    font-size: $st_font-size-small;
    padding: 0 4px;
  }
}

/deep/ {
  .md-steppers {
    padding-top: 10px;
    padding-bottom: 36px;

    @include media-breakpoint-up(md) {
      padding-top: 35px;
      padding-bottom: 68px;
    }

    @include media-breakpoint-down(sm) {
      background-color: $st_color_transparent;
    }

    .md-steppers-navigation {
      max-width: 860px;
      margin: 0 auto;
      margin-bottom: 40px;
      box-shadow: none;

      @include media-breakpoint-up(md) {
        margin-bottom: 70px;
      }

      .md-stepper-header {
        position: relative;
        overflow: visible;
        min-width: auto;

        &:hover {
          &::before {
            background-color: $st_color_transparent;
          }
        }

        &:disabled,
        &.disabled {
          .md-ripple {
            .md-button-content {
              .md-stepper-number {
                background-color: $st_color_gray_light;
              }

              .md-stepper-text {
                color: $st_color_gray_dark;
              }
            }
          }
        }

        &.md-active {
          .md-ripple {
            .md-button-content {
              .md-stepper-number {
                background-color: rgba(#00abc3, 0.7);
              }
            }
          }
        }

        &.md-done {
          .md-ripple {
            .md-button-content {
              .md-stepper-number {
                background-color: #00abc3;
              }
            }
          }
        }

        &:not(:last-child) {
          &::after {
            content: '';
            display: block;
            position: absolute;
            right: -30%;
            top: 32%;
            height: 2px;
            width: 62%;
            background-color: rgba($st_color_gray_light, 0.5);

            @include media-breakpoint-up(md) {
              right: -20%;
              top: 50%;
              width: 40%;
            }
          }
        }

        .md-ripple {
          justify-content: center;

          @include media-breakpoint-down(sm) {
            padding: 0;
          }

          .md-button-content {
            font-weight: 500;

            &::after,
            &::before {
              display: none;
            }

            @include media-breakpoint-down(sm) {
              padding: 0;
              display: block;
            }

            .md-stepper-number {
              @include media-breakpoint-down(sm) {
                font-size: $st_font-size-small;
                letter-spacing: 0.7px;
                width: 21px;
                height: 21px;
                margin: 0 auto;
                margin-bottom: 9px;
                line-height: $st_font-line-height-base;
              }

              .md-stepper-done {
                @include media-breakpoint-down(sm) {
                  transform: translate(-1px, -2px);
                  width: 13px;
                  height: 13px;
                }
              }
            }

            .md-stepper-text {
              font-size: $st_font-size-small;
              letter-spacing: 0.7px;
              color: $st_color_gray_darker;

              @include media-breakpoint-up(md) {
                font-size: $st_font-size-big;
                letter-spacing: 0.9px;
              }
            }
          }

          .md-ripple-wave {
            background-color: #00abc3;
          }
        }
      }
    }

    &--isExpired {
      .md-steppers-navigation {
        .md-stepper-header {
          &.md-done,
          &[disabled] {
            .md-ripple {
              .md-button-content {
                .md-stepper-number {
                  background-color: $st_color_gray_light;
                }

                .md-stepper-text {
                  color: $st_color_gray_light;
                }
              }
            }
          }

          &.md-active {
            .md-ripple {
              .md-button-content {
                .md-stepper-number {
                  background-color: $st_color_gray;
                }

                .md-stepper-text {
                  color: $st_color_gray;
                }
              }
            }
          }
        }
      }
    }

    .md-steppers-wrapper {
      .md-stepper {
        padding: 0;
      }
    }
  }

  .multiselect__tags {
    cursor: default;
  }

  .multiselect__content-wrapper {
    overflow-x: hidden;
    z-index: 100;
  }

  .multiselect--disabled .multiselect__select {
    display: none;
  }

  .multiselect__option {
    color: $st_color_gray_darker;

    &--highlight {
      background: #e1e1e1;
      color: $st_color_gray_darker;

      &.multiselect__option--selected {
        background: #f3f3f3;
        color: $st_color_gray_darker;
      }
    }
  }
}

.payment--border {
  border-top: 2px solid $st_color_gray_lighter;
}

.stepSelect {
  max-width: 850px;

  &__title {
    margin-bottom: 20px;

    @include media-breakpoint-up(md) {
      margin-bottom: 90px;
      font-size: $st_font-size-biggest;
      line-height: $st_font-line-height-biggest;
      letter-spacing: $st_font_letter-spacing;
    }
  }

  &__ticket {
    &__checkbox {
      pointer-events: none;

      @include media-breakpoint-up(md) {
        pointer-events: all;
      }

      /deep/ {
        .md-checkbox-container {
          width: 21px;
          height: 21px;
          min-width: auto;
          border-color: rgba($st_color_gray_light, 0.5);

          @include media-breakpoint-up(md) {
            width: 24px;
            height: 24px;
          }

          &::after {
            width: 7px;
            height: 13px;

            @include media-breakpoint-up(md) {
              width: 9px;
              height: 15px;
            }
          }
        }
      }

      &.md-disabled {
        /deep/ {
          .md-checkbox-container {
            background-color: $st_color_gray_lighter;
            border-color: $st_color_gray_lighter;
          }
        }
      }

      &.md-checked {
        /deep/ {
          .md-checkbox-container {
            background-color: $st_color_sub_light;
            border-color: $st_color_sub_light;

            .md-ripple {
              color: $st_color_sub_light;
            }
          }
        }
      }
    }

    &-label {
      position: relative;
      z-index: 1;
      cursor: pointer;
      box-shadow: 0 0 6px 0 #b6b9be;
      background-color: $st_color_white;
      user-select: none;
      $stepSelect__ticket-label: &;

      @include media-breakpoint-up(md) {
        background-color: $st_color_transparent;
        border: 2px solid $st_color_gray_lighter;
        box-shadow: none;
        min-height: 160px;

        &::before {
          height: 11px;
          width: calc(100% + 4px);
          position: absolute;
          left: -2px;
          bottom: -13px;
          content: '';
          background-color: rgba(236, 238, 239, 0.3);
          z-index: 4;
        }
      }

      &-left {
        height: auto;

        @include media-breakpoint-down(sm) {
          &::before,
          &::after {
            content: '';
            position: absolute;
            height: 17px;
            width: 10px;
            bottom: 1px;
            background-color: #f5f6fa;
            z-index: 4;
          }

          &:before {
            left: -33px;
          }

          &:after {
            right: -33px;
          }
        }

        @include media-breakpoint-up(md) {
          height: 100%;
        }

        &__dashed-line {
          position: absolute;
          z-index: 3;
          border-bottom: 1px dashed rgba($st_color_gray_light, 0.5);
          width: calc(100% + 24px);
          left: -12px;
          bottom: 9px;

          @include media-breakpoint-up(md) {
            left: auto;
            bottom: auto;
            top: -5px;
            right: 6px;
            height: calc(100% + 10px);
            width: auto;
            border-right: 1px dashed rgba($st_color_gray_light, 0.5);
            border-bottom: none;
          }

          &::after,
          &::before {
            content: '';
            position: absolute;
            height: 19px;
            width: 10px;
            bottom: -10px;
            background-color: #f5f6fa;

            @include media-breakpoint-up(md) {
              bottom: auto;
              height: 9px;
              width: 20px;
              border: 2px solid $st_color_gray_lighter;
            }
          }

          &:before {
            left: -13px;
            border-radius: 0 16px 16px 0;
            box-shadow: inset -1px 0 3px 0 rgba(#b6b9be, 0.5);

            @include media-breakpoint-up(md) {
              box-shadow: none;
              left: auto;
              top: -13px;
              right: -10px;
              border-radius: 0 0 16px 16px;
              border-top-color: $st_color_white;
              background-color: $st_color_white;
            }
          }

          &:after {
            right: -13px;
            border-radius: 16px 0 0 16px;
            box-shadow: inset 1px 0 3px 0 rgba(#b6b9be, 0.5);

            @include media-breakpoint-up(md) {
              box-shadow: none;
              bottom: -13px;
              right: -10px;
              border-radius: 16px 16px 0 0;
              border-bottom-color: $st_color_transparent;
              background: linear-gradient(to right, rgba(236, 238, 239, 0.3), rgba(236, 238, 239, 0.3)) $st_color_white;
            }
          }
        }
      }

      &--selected {
        box-shadow: 0 0 8px 0 $st_color_sub;

        @include media-breakpoint-up(md) {
          box-shadow: none;
          border-color: $st_color_sub_light;
          background-color: rgba($st_color_sub_light, 0.08);
        }

        #{$stepSelect__ticket-label}-left {
          &__dashed-line {
            border-right-color: $st_color_sub_light;

            &::after,
            &::before {
              border-color: $st_color_sub_light;
            }

            &::before {
              box-shadow: inset -1px 0 3px 0 rgba($st_color_sub, 0.5);

              @include media-breakpoint-up(md) {
                border-top-color: $st_color_white;
                box-shadow: none;
              }
            }

            &::after {
              box-shadow: inset 1px 0 3px 0 rgba($st_color_sub, 0.5);

              @include media-breakpoint-up(md) {
                border-bottom-color: $st_color_transparent;
                box-shadow: none;
              }
            }
          }
        }

        #{$stepSelect__ticket-label}-right {
          @include media-breakpoint-down(sm) {
            &::before {
              display: block;
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 67px;
              background-color: rgba($st_color_sub_light, 0.08);
              z-index: 2;
            }
          }
        }

        #{$stepSelect__ticket-label}__name,
        #{$stepSelect__ticket-label}__event-name {
          @include media-breakpoint-down(sm) {
            color: $st_color_sub;
          }
        }
      }

      &--non-start {
        #{$stepSelect__ticket-label}__currency {
          color: $st_color_gray;

          @include media-breakpoint-up(md) {
            color: $st_color_gray_light;
          }
        }

        #{$stepSelect__ticket-label}__price {
          color: $st_color_gray;

          @include media-breakpoint-up(md) {
            color: $st_color_gray_light;
          }
        }

        #{$stepSelect__ticket-label}__message {
          background-color: $st_color_transparent;
          color: $st_color_gray_light;
          max-width: 85px;

          @include media-breakpoint-up(md) {
            max-width: none;
          }
        }
      }

      &--ended {
        #{$stepSelect__ticket-label}__currency {
          @include media-breakpoint-up(md) {
            color: $st_color_gray;
          }
        }

        #{$stepSelect__ticket-label}__price {
          @include media-breakpoint-up(md) {
            color: $st_color_gray;
          }
        }

        #{$stepSelect__ticket-label}__message {
          border-radius: 12px;
          max-width: 85px;
          background-color: $st_color_gray_light;

          @include media-breakpoint-up(md) {
            max-width: 97px;
          }
        }
      }

      &--fulled {
        border-color: rgba($st_color_gray_dark, 0.5);

        #{$stepSelect__ticket-label}-left {
          &__dashed-line {
            &::before {
              @include media-breakpoint-up(md) {
                border-right-color: rgba($st_color_gray_dark, 0.5);
                border-left-color: rgba($st_color_gray_dark, 0.5);
                border-bottom-color: rgba($st_color_gray_dark, 0.5);
              }
            }

            &::after {
              @include media-breakpoint-up(md) {
                border-color: rgba($st_color_gray_dark, 0.5) rgba($st_color_gray_dark, 0.5) rgba(236, 238, 239, 0.3) rgba($st_color_gray_dark, 0.5);
              }
            }
          }
        }

        #{$stepSelect__ticket-label}__message {
          position: absolute;
          z-index: 2;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 67px;
          background-color: rgba($st_color_gray_dark, 0.5);
          font-size: $st_font-size-big;
          line-height: $st_font-line-height-big;
          letter-spacing: $st_font_letter-spacing;

          @include media-breakpoint-up(md) {
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            font-size: 28px;
            line-height: $st_font-line-height-big;
            letter-spacing: 1.24px;
          }
        }
      }

      &--non-start,
      &--ended,
      &--fulled {
        cursor: default;
      }

      &__name {
        overflow: hidden;
        text-overflow: ellipsis;

        @include media-breakpoint-up(md) {
          font-size: $st_font-size-biggest;
          line-height: $st_font-line-height-big;
          letter-spacing: 1.07px;
        }
      }

      &__event-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        @include media-breakpoint-up(md) {
          font-size: $st_font-size-base;
          line-height: $st_font-line-height-big;
          letter-spacing: 1px;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
      }

      &__conditions {
        i {
          font-size: 10px;
        }

        &__or {
          border-bottom: 2px solid $st_color_gray_lighter;

          @include media-breakpoint-up(md) {
            border-bottom: none;
            border-top: 2px solid $st_color_gray_lighter;
          }
        }

        &__forAll {
          @include media-breakpoint-up(md) {
            color: $st_color_gray;
          }
        }

        &__forSubscription {
          &__channel-items {
            margin-bottom: -($spacer * .25);

            a {
              background-color: rgba($st_color_sub_light, 0.1);
              border-radius: 20px;

              &:hover {
                color: $st_color_sub_light;
              }
            }
          }
        }

        &__forEvent {
          a {
            &:hover {
              color: $st_color_gray_dark;
            }
          }
        }
      }

      &__message {
        width: 100%;

        @include media-breakpoint-up(md) {
          font-size: $st_font-size-big;
          line-height: $st_font-line-height-big;
          letter-spacing: $st_font_letter-spacing;
        }
      }

      &__currency {
        @include media-breakpoint-up(md) {
          font-size: $st_font-size-bigger;
          line-height: $st_font-line-height-big;
          letter-spacing: 2.37px;
        }
      }

      &__price {
        font-size: 28px;
        letter-spacing: 2.03px;

        @include media-breakpoint-up(md) {
          font-size: 36px;
          line-height: $st_font-line-height-big;
          letter-spacing: 2.37px;
        }
      }
    }

    &__detail {
      box-shadow: 0 0 6px 0 #b6b9be;
      background-color: rgba(236, 238, 239, 0.3);
      font-size: $st_font-size-small;
      letter-spacing: $st_font_letter-spacing;
      color: $st_color_gray_dark;

      &-content {
        white-space: pre-line;
      }

      @include media-breakpoint-up(md) {
        box-shadow: none;
        color: #76787d;
      }

      &-title {
        white-space: normal;
        font-size: $st_font-size-base;
        line-height: 24px;
        letter-spacing: $st_font_letter-spacing;
        font-weight: $st_font-weight-medium;
      }

      &-usage {
        border-left: 4px solid $st_color_gray_lighter;

        @include media-breakpoint-up(md) {
          border-left: none;
        }
      }

      &-label {
        font-weight: $st_font-weight-medium;
      }

      &-date {
        font-size: $st_font-size-smaller;
        letter-spacing: 0.64px;

        @include media-breakpoint-up(md) {
          font-size: $st_font-size-small;
          letter-spacing: 0.75px;
        }
      }
    }

    &__collapsed-button {
      &:not(:disabled):not(.disabled):hover,
      &:not(:disabled):not(.disabled):active {
        background-color: $st_color_transparent;
        color: $st_color_main_lightest;
      }

      &.collapsed {
        i {
          margin-top: 0;
          margin-bottom: 6px;
          transform: rotate(0deg);
        }
      }

      i {
        margin-top: 10px;
        transform: rotate(-180deg);
      }
    }

    &__previous-button,
    &__next-button {
      min-width: auto;
      max-width: 235px;
      width: 100%;
    }

    &__next-button {
      margin-top: 47px;

      @include media-breakpoint-up(md) {
        margin-top: 113px;
      }
    }

    &__previous-button {
      color: $st_color_main_lightest;
      border: 2px solid $st_color_gray_lighter;
      border-radius: 2px;
      background-color: $st_color_transparent;
    }
  }
}

.stepUserInfo {
  h2 {
    @include media-breakpoint-up(md) {
      font-size: 28px;
      line-height: $st_font-line-height-big;
      letter-spacing: 1.24px;
    }
  }

  &__purchase {
    @include media-breakpoint-up(md) {
      @important {
        margin-bottom: 40px;
      }
    }

    &__copy {
      border-width: 2px;
      border-color: $st_color_gray_lighter;

      &:not(:disabled):not(.disabled):active,
      &:not(:disabled):not(.disabled):hover {
        background-color: $st_color_transparent;
        color: $st_color_main_lightest;
        border-color: $st_color_gray_lighter;
      }
    }

    &__form {
      box-shadow: 0 0 6px 0 #b6b9be;
      padding: 29px 22px 32px 22px;

      @include media-breakpoint-up(md) {
        padding: 50px 47px 60px 56px;
      }

      h3 {
        margin-bottom: 36px;

        @include media-breakpoint-up(md) {
          font-weight: $st_font-weight-light;
          font-size: 28px;
          line-height: 0.93;
          letter-spacing: 1.24px;
          margin-bottom: 57px;
        }
      }

      /deep/ input {
        height: 44px;
      }
    }

    &__next-button,
    &__cancel-button {
      min-width: auto;
      max-width: 235px;
      width: 100%;
    }

    &__next-button {
      margin-top: 45px;

      @include media-breakpoint-up(md) {
        margin-top: 74px;
      }
    }

    &__cancel-button {
      color: $st_color_main_lightest;
      border: 2px solid $st_color_gray_lighter;
      border-radius: 2px;
      background-color: $st_color_transparent;
    }
  }
}

.expiration {
  &__content {
    border: 2px solid $st_color_gray_lighter;
    padding: 40px 15px;
    margin-bottom: 30px;

    @include media-breakpoint-up(md) {
      margin-bottom: 68px;
    }

    > span {
      @include media-breakpoint-up(md) {
        font-size: $st_font-size-big;
        line-height: $st_font-line-height-biggest;
        letter-spacing: 0.6px;
      }
    }

    &__timer {
      font-size: $st_font-size-small;
      line-height: $st_font-line-height-biggest;
      letter-spacing: 0.47px;
      color: #ff9425;
    }
  }

  &__resubmit-button,
  &__back {
    min-width: auto;
    max-width: 235px;
  }

  &__back {
    background-color: $st_color_transparent;
    color: $st_color_main_lightest;
    border: 2px solid $st_color_gray_lighter;
  }
}

.creditCard {
  &__block {
    background: rgba(236, 238, 239, 0.3);
    border-top: 2px solid $st_color_gray_lighter;
    border-bottom: 2px solid $st_color_gray_lighter;

    @include media-breakpoint-up(md) {
      padding: 32px;
      border-bottom: none;
    }
  }

  &__inside {
    max-width: 500px;
  }

  &__input {
    width: 100%;
    height: 100%;
    border: none;
    padding: 0 0.5rem;
    color: $st_color_gray_darker;
    box-shadow: none;
    outline: none;

    &::placeholder {
      color: $st_color_gray_light;
    }
  }

  &__number {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;

    &__icon {
      margin-top: -4px;
    }
  }

  &__expiry {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;
  }

  &__ccv {
    border-radius: 2px;
    background-color: $st_color_white;
    border: solid 2px $st_color_gray_lighter;
    height: 45px;
    box-sizing: border-box;
  }

  &__state {
    &--true {
      border-color: $st_color_success;
    }

    &--false {
      border-color: $st_color_error;
    }
  }
}

.text-overflow-1-line {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  word-break: break-all;
  white-space: initial;
  line-height: initial;
}

.payChoose {
  margin: 0 -15px;

  &--border {
    &Mobile {
      @include media-breakpoint-down(sm) {
        border-top: 2px solid $st_color_gray_lighter;
        border-bottom: 2px solid $st_color_gray_lighter;
      }
    }

    @include media-breakpoint-up(md) {
      &Desktop {
        border: 2px solid $st_color_gray_lighter;
      }
    }

    &Bottom {
      border-bottom: 2px solid $st_color_gray_lighter;
    }

    &Dashed {
      @include media-breakpoint-up(md) {
        border-bottom: 1px dashed rgba(184, 188, 195, 0.5);
      }
    }
  }

  &__price, &__payFee {
    color: $st_color_main;
    font-size: $st_font-size-small;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-base;
    }
  }

  &__margin {
    background: #f6f6f6;
    height: 20px;
  }

  &__linePay {
    font-size: $st_font-size-smaller;
    color: #1278f6;
    letter-spacing: 0.6px;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-small;
      letter-spacing: $st_font_letter-spacing;
    }
  }
}

.receiptWrite {
  &__title {
    font-size: $st_font-size-big;
    color: $st_color_main_light;
    font-weight: $st_font-weight-normal;
    letter-spacing: $st_font_letter-spacing;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-biggest;
      color: $st_color_main;
    }
  }

  &__inputTitle {
    font-size: $st_font-size-small;
    color: #2a3260;
    font-weight: $st_font-weight-normal;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-base;
      color: $st_color_main_light;
    }
  }

  &--border {
    &Dashed {
      @include media-breakpoint-up(md) {
        border-bottom: 1px dashed rgba(184, 188, 195, 0.5);
      }
    }

    &Mobile {
      @include media-breakpoint-down(sm) {
        border-top: 2px solid $st_color_gray_lighter;
        border-bottom: 2px solid $st_color_gray_lighter;
      }
    }
  }

  &__margin {
    background: #f6f6f6;
    height: 20px;
  }

  &__personal {
    @include media-breakpoint-up(md) {
      border: 2px solid $st_color_gray_lighter;
      margin-top: 8px;
      padding: 20px 31px 20px 20px;
    }
  }
}

.agreement {
  &__title {
    font-size: $st_font-size-big;
    color: $st_color_main_light;
    font-weight: $st_font-weight-normal;
    letter-spacing: $st_font_letter-spacing;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-biggest;
      color: $st_color_main;
    }
  }

  &--border {
    &Dashed {
      @include media-breakpoint-up(md) {
        border-bottom: 1px dashed rgba(184, 188, 195, 0.5);
      }
    }

    &Mobile {
      @include media-breakpoint-down(sm) {
        border-top: 2px solid $st_color_gray_lighter;
        border-bottom: 2px solid $st_color_gray_lighter;
      }
    }
  }

  /deep/ &__description.md-checkbox .md-checkbox-label {
    font-size: $st_font-size-smaller;
    color: $st_color_main_light;
    letter-spacing: 0.7px;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-base;
      letter-spacing: $st_font_letter-spacing;
    }
  }
}

.action {
  background: #f6f6f6;

  @include media-breakpoint-up(md) {
    background: $st_color_white;
  }

  &__tappay {
    width: 75px;
  }

  &__description {
    font-size: $st_font-size-smaller;
    color: $st_color_gray_dark;
    font-weight: $st_font-weight-normal;

    @include media-breakpoint-up(md) {
      font-size: $st_font-size-small;
    }
  }
}

@include media-breakpoint-up(md) {
  .payChoose {
    &__way__title {
      background: transparent;

      h5 {
        font-size: $st_font-size-big;
      }
    }

    &__amount {
      border-top: 2px solid $st_color_gray_lighter;

      &__title {
        background: transparent;

        h5 {
          font-size: $st_font-size-big;
          margin-left: 15px;
        }
      }

      &__input {
        @important {
          justify-content: flex-start;
        }
      }
    }
  }

  .receiptWrite {
    &__required {
      @important {
        text-align: left;
      }
    }
  }
}

.paymentMethod {
  /deep/ {
    .md-radio-label {
      height: auto;
    }
  }
}
</style>
